
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hOJ7X", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cf8a1c8e46a83292$export$2e2bcd8739ae039; });

var $iDGsT = parcelRequire("iDGsT");

var $1oC0p = parcelRequire("1oC0p");

var $brpgD = parcelRequire("brpgD");

var $6FgUR = parcelRequire("6FgUR");

var $dK6Gj = parcelRequire("dK6Gj");
var $cf8a1c8e46a83292$var$AsyncSelect = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    // when isAsync is true, options are not provided and async props are used, we will enable async
    var isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    var stateManagedProps = (0, $6FgUR.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    var selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    var selectProps = (0, $dK6Gj.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $brpgD.default), (0, $iDGsT.default)({
        ref: ref
    }, selectProps));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cf8a1c8e46a83292$export$2e2bcd8739ae039 = $cf8a1c8e46a83292$var$AsyncSelect;

});
parcelRegister("iDGsT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d91ccf3094200835$export$2e2bcd8739ae039; });
function $d91ccf3094200835$export$2e2bcd8739ae039() {
    return $d91ccf3094200835$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d91ccf3094200835$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("brpgD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8545d0e8c5603027$export$2e2bcd8739ae039; });

var $iDGsT = parcelRequire("iDGsT");
parcelRequire("7vSNf");

var $5wtQz = parcelRequire("5wtQz");

var $1L9xr = parcelRequire("1L9xr");

var $gk4W6 = parcelRequire("gk4W6");

var $hz9hK = parcelRequire("hz9hK");

var $gWRUU = parcelRequire("gWRUU");

var $9gsna = parcelRequire("9gsna");

var $gp1ED = parcelRequire("gp1ED");

var $c5fcX = parcelRequire("c5fcX");

var $1oC0p = parcelRequire("1oC0p");

var $Ej25m = parcelRequire("Ej25m");

var $39c3M = parcelRequire("39c3M");

var $jfUrB = parcelRequire("jfUrB");

var $4lRXd = parcelRequire("4lRXd");

var $a61YJ = parcelRequire("a61YJ");
var $UaMzL = parcelRequire("UaMzL");
var $iFQY6 = parcelRequire("iFQY6");

var $gFMof = parcelRequire("gFMof");

var $go0Tl = parcelRequire("go0Tl");

var $4E002 = parcelRequire("4E002");

var $gdrG4 = parcelRequire("gdrG4");

var $2tUXn = parcelRequire("2tUXn");

var $aFLwO = parcelRequire("aFLwO");
function $8545d0e8c5603027$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8545d0e8c5603027$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8545d0e8c5603027$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gp1ED.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8545d0e8c5603027$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8545d0e8c5603027$var$_callSuper(t, o, e) {
    return o = (0, $gWRUU.default)(o), (0, $hz9hK.default)(t, $8545d0e8c5603027$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $gWRUU.default)(t).constructor) : o.apply(t, e));
}
function $8545d0e8c5603027$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8545d0e8c5603027$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $8545d0e8c5603027$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $aFLwO.isTouchCapable)(),
    captureMenuScroll: !(0, $aFLwO.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $gdrG4.createFilter)(),
    formatGroupLabel: (0, $jfUrB.formatGroupLabel),
    getOptionLabel: (0, $jfUrB.getOptionLabel),
    getOptionValue: (0, $jfUrB.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $jfUrB.isOptionDisabled),
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $aFLwO.isMobileDevice)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false,
    shouldKeepInputOnSelect: false
};
function $8545d0e8c5603027$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $8545d0e8c5603027$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $8545d0e8c5603027$var$_isOptionSelected(props, option, selectValue);
    var label = $8545d0e8c5603027$var$getOptionLabel(props, option);
    var value = $8545d0e8c5603027$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $8545d0e8c5603027$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        //@ts-ignore
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $8545d0e8c5603027$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $8545d0e8c5603027$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $8545d0e8c5603027$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $8545d0e8c5603027$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $aFLwO.notNullish));
}
function $8545d0e8c5603027$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $c5fcX.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $8545d0e8c5603027$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $c5fcX.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $8545d0e8c5603027$var$buildFocusableOptions(props, selectValue) {
    return $8545d0e8c5603027$var$buildFocusableOptionsFromCategorizedOptions($8545d0e8c5603027$var$buildCategorizedOptions(props, selectValue));
}
function $8545d0e8c5603027$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$8545d0e8c5603027$var$shouldHideSelectedOptions(props) || !isSelected) && $8545d0e8c5603027$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $8545d0e8c5603027$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $8545d0e8c5603027$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $8545d0e8c5603027$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $8545d0e8c5603027$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $8545d0e8c5603027$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $8545d0e8c5603027$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $8545d0e8c5603027$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $8545d0e8c5603027$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $8545d0e8c5603027$var$getOptionValue(props, i) === candidate;
    });
}
function $8545d0e8c5603027$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $8545d0e8c5603027$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $8545d0e8c5603027$var$instanceId = 1;
// eslint-disable-next-line @repo/internal/react/no-class-components
var $8545d0e8c5603027$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $1L9xr.default)(this, Select);
        _this = $8545d0e8c5603027$var$_callSuper(this, Select, [
            _props
        ]);
        (0, $gp1ED.default)(_this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        });
        // Misc. Instance Properties
        // ------------------------------
        (0, $gp1ED.default)(_this, "blockOptionHover", false);
        (0, $gp1ED.default)(_this, "isComposing", false);
        // TODO
        (0, $gp1ED.default)(_this, "initialTouchX", 0);
        (0, $gp1ED.default)(_this, "initialTouchY", 0);
        (0, $gp1ED.default)(_this, "openAfterFocus", false);
        (0, $gp1ED.default)(_this, "scrollToFocusedOptionOnUpdate", false);
        // Refs
        // ------------------------------
        (0, $gp1ED.default)(_this, "controlRef", null);
        (0, $gp1ED.default)(_this, "getControlRef", function(ref) {
            _this.controlRef = ref;
        });
        (0, $gp1ED.default)(_this, "focusedOptionRef", null);
        (0, $gp1ED.default)(_this, "getFocusedOptionRef", function(ref) {
            _this.focusedOptionRef = ref;
        });
        (0, $gp1ED.default)(_this, "menuListRef", null);
        (0, $gp1ED.default)(_this, "getMenuListRef", function(ref) {
            _this.menuListRef = ref;
        });
        (0, $gp1ED.default)(_this, "inputRef", null);
        (0, $gp1ED.default)(_this, "getInputRef", function(ref) {
            _this.inputRef = ref;
        });
        // aliased for consumers
        (0, $gp1ED.default)(_this, "focus", _this.focusInput);
        (0, $gp1ED.default)(_this, "blur", _this.blurInput);
        (0, $gp1ED.default)(_this, "onChange", function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        (0, $gp1ED.default)(_this, "setValue", function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue, shouldKeepInputOnSelect = _this$props2.shouldKeepInputOnSelect;
            // for multiple selection options, do not clear the search input value
            if (isMulti && shouldKeepInputOnSelect && (0, $39c3M.fg)('platform_do_not_clear_input_for_multiselect')) _this.onInputChange(inputValue, {
                action: 'set-value',
                prevInputValue: inputValue
            });
            else _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        (0, $gp1ED.default)(_this, "selectOption", function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $aFLwO.multiValueAsValue)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $aFLwO.multiValueAsValue)([].concat((0, $c5fcX.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $aFLwO.singleValueAsValue)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $aFLwO.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        });
        (0, $gp1ED.default)(_this, "removeValue", function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $aFLwO.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        });
        (0, $gp1ED.default)(_this, "clearValue", function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $aFLwO.valueTernary)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        });
        (0, $gp1ED.default)(_this, "popValue", function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $aFLwO.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        });
        // ==============================
        // Getters
        // ==============================
        (0, $gp1ED.default)(_this, "getFocusedOptionId", function(focusedOption) {
            return $8545d0e8c5603027$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        });
        (0, $gp1ED.default)(_this, "getFocusableOptionsWithIds", function() {
            return $8545d0e8c5603027$var$buildFocusableOptionsWithIds($8545d0e8c5603027$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        });
        (0, $gp1ED.default)(_this, "getValue", function() {
            return _this.state.selectValue;
        });
        (0, $gp1ED.default)(_this, "cx", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $aFLwO.classNames).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        });
        (0, $gp1ED.default)(_this, "getOptionLabel", function(data) {
            return $8545d0e8c5603027$var$getOptionLabel(_this.props, data);
        });
        (0, $gp1ED.default)(_this, "getOptionValue", function(data) {
            return $8545d0e8c5603027$var$getOptionValue(_this.props, data);
        });
        (0, $gp1ED.default)(_this, "getStyles", function(key, props) {
            var base = (0, $2tUXn.defaultStyles)[key](props);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            if (!custom) return base;
            var customStyles = (0, $aFLwO.filterUnsupportedSelectors)(custom(base, props));
            return customStyles;
        });
        (0, $gp1ED.default)(_this, "getClassNames", function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        });
        (0, $gp1ED.default)(_this, "getElementId", function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        });
        (0, $gp1ED.default)(_this, "getComponents", function() {
            return (0, $4lRXd.defaultComponents)(_this.props);
        });
        (0, $gp1ED.default)(_this, "buildCategorizedOptions", function() {
            return $8545d0e8c5603027$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        });
        (0, $gp1ED.default)(_this, "getCategorizedOptions", function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        });
        (0, $gp1ED.default)(_this, "buildFocusableOptions", function() {
            return $8545d0e8c5603027$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        });
        (0, $gp1ED.default)(_this, "getFocusableOptions", function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        });
        // ==============================
        // Helpers
        // ==============================
        (0, $gp1ED.default)(_this, "ariaOnChange", function(value, actionMeta) {
            _this.setState({
                ariaSelection: $8545d0e8c5603027$var$_objectSpread({
                    value: value
                }, actionMeta)
            });
        });
        // ==============================
        // Mouse Handlers
        // ==============================
        (0, $gp1ED.default)(_this, "onMenuMouseDown", function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        });
        (0, $gp1ED.default)(_this, "onMenuMouseMove", function(event) {
            _this.blockOptionHover = false;
        });
        (0, $gp1ED.default)(_this, "onControlMouseDown", function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = _this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        });
        (0, $gp1ED.default)(_this, "onDropdownIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        });
        (0, $gp1ED.default)(_this, "onClearIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        });
        (0, $gp1ED.default)(_this, "onScroll", function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $aFLwO.isDocumentElement)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        });
        (0, $gp1ED.default)(_this, "onCompositionStart", function() {
            _this.isComposing = true;
        });
        (0, $gp1ED.default)(_this, "onCompositionEnd", function() {
            _this.isComposing = false;
        });
        (0, $gp1ED.default)(_this, "onTouchStart", function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        });
        (0, $gp1ED.default)(_this, "onTouchMove", function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        (0, $gp1ED.default)(_this, "onTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        });
        (0, $gp1ED.default)(_this, "onControlTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        });
        (0, $gp1ED.default)(_this, "onClearIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        });
        (0, $gp1ED.default)(_this, "onDropdownIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        });
        // ==============================
        // Focus Handlers
        // ==============================
        (0, $gp1ED.default)(_this, "handleInputChange", function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        });
        (0, $gp1ED.default)(_this, "onInputFocus", function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        });
        (0, $gp1ED.default)(_this, "onInputBlur", function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $39c3M.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            _this.props.menuIsOpen && _this.onMenuClose();
            else _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        (0, $gp1ED.default)(_this, "onOptionHover", function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        });
        (0, $gp1ED.default)(_this, "shouldHideSelectedOptions", function() {
            return $8545d0e8c5603027$var$shouldHideSelectedOptions(_this.props);
        });
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        (0, $gp1ED.default)(_this, "onValueInputFocus", function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        });
        // ==============================
        // Keyboard Handlers
        // ==============================
        (0, $gp1ED.default)(_this, "onKeyDown", function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus, shouldPreventEscapePropagation = _this$props5.shouldPreventEscapePropagation;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) _this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        (0, $gp1ED.default)(_this, "handleOpenLayerObserverCloseSignal", function() {
            _this.onMenuClose();
        });
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$8545d0e8c5603027$var$instanceId);
        _this.state.selectValue = (0, $aFLwO.cleanValue)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $8545d0e8c5603027$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $9gsna.default)(Select, _Component);
    return (0, $gk4W6.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $aFLwO.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $aFLwO.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                var focusedOption = focusableOptions[openAtIndex];
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusedOption,
                    focusedOptionId: this.getFocusedOptionId(focusedOption)
                }, function() {
                    return _this2.onMenuOpen();
                });
                (0, $Ej25m.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
            }
        },
        {
            key: "updateInputLabel",
            value: function updateInputLabel(inputLabel) {
                var _this3 = this;
                if (inputLabel) {
                    var _this$inputRef;
                    (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute('aria-label', inputLabel);
                    setTimeout(function() {
                        var normalizedLabel = _this3.props['aria-label'] || _this3.props.label;
                        if (normalizedLabel) {
                            var _this3$inputRef;
                            (_this3$inputRef = _this3.inputRef) === null || _this3$inputRef === void 0 || _this3$inputRef.setAttribute('aria-label', normalizedLabel);
                        } else {
                            var _this3$inputRef2;
                            (_this3$inputRef2 = _this3.inputRef) === null || _this3$inputRef2 === void 0 || _this3$inputRef2.removeAttribute('aria-label');
                        }
                    }, 500);
                }
            }
        },
        {
            key: "calculateInputLabel",
            value: function calculateInputLabel(focusedOption, optionIndex) {
                var _this4 = this;
                var options = this.props.options;
                var isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every(function(obj) {
                    return (0, $5wtQz.default)(obj) === 'object' && obj !== null && 'options' in obj;
                });
                var inputLabel = this.getOptionLabel(focusedOption);
                var isOptionFocused = function isOptionFocused(option) {
                    return _this4.getOptionLabel(option) === inputLabel;
                };
                var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
                    var _groupCandidate$optio, _groupCandidate$optio2;
                    var groupCandidate = option;
                    return (_groupCandidate$optio = (_groupCandidate$optio2 = groupCandidate.options) === null || _groupCandidate$optio2 === void 0 ? void 0 : _groupCandidate$optio2.some(isOptionFocused)) !== null && _groupCandidate$optio !== void 0 ? _groupCandidate$optio : false;
                });
                if (isOptionsGrouped) {
                    var _groupData$options$fi;
                    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
                    var totalLength = options === null || options === void 0 ? void 0 : options.reduce(function(acc, currentGroup) {
                        var _group$options;
                        var group = currentGroup;
                        acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                        return acc;
                    }, 0);
                    inputLabel = "".concat(inputLabel, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " (").concat(groupOptionIndex + 1, " of ").concat(totalLength, ")");
                } else inputLabel = "".concat(inputLabel, " (").concat(optionIndex + 1, " of ").concat(options === null || options === void 0 ? void 0 : options.length, ")");
                return inputLabel;
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus],
                    focusedValueId: "".concat(this.getElementId('selected-value'), "-").concat(nextFocus, "-remove"),
                    focusedOption: null,
                    focusedOptionId: null
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedValueId: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $8545d0e8c5603027$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $8545d0e8c5603027$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $8545d0e8c5603027$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "calculateDescription",
            value: function calculateDescription() {
                var descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
                var isMulti = this.props.isMulti;
                var hasValue = this.state.selectValue.length > 0;
                // Determine base description based on selection state
                var baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
                // Fast path for single select with no description prop
                if (!isMulti && !descriptionProp) return {
                    'aria-describedby': baseDescriptionId
                };
                // Build the describedby string efficiently
                var describedBy = baseDescriptionId;
                // Add description prop if it exists
                if (descriptionProp) describedBy = describedBy ? "".concat(descriptionProp, " ").concat(describedBy) : descriptionProp;
                // For multi-select, always add multi-message ID
                if (isMulti) {
                    var multiMessage = this.getElementId('multi-message');
                    describedBy = describedBy ? "".concat(describedBy, " ").concat(multiMessage) : multiMessage;
                }
                return {
                    'aria-describedby': describedBy
                };
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchstart', this.onTouchStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchmove', this.onTouchMove);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, form = _this$props8.form, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, isDisabled = _this$props8.isDisabled, isInvalid = _this$props8.isInvalid, isRequired = _this$props8.isRequired, isSearchable = _this$props8.isSearchable, label = _this$props8.label, labelId = _this$props8.labelId, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required, _this$props8$tabIndex = _this$props8.tabIndex, tabIndex = _this$props8$tabIndex === void 0 ? 0 : _this$props8$tabIndex, testId = _this$props8.testId;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = $8545d0e8c5603027$var$_objectSpread($8545d0e8c5603027$var$_objectSpread($8545d0e8c5603027$var$_objectSpread({
                    'aria-autocomplete': 'both',
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-expanded': menuIsOpen,
                    // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
                    'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                    'aria-invalid': this.props['aria-invalid'] || isInvalid,
                    'aria-label': this.props['aria-label'] || label,
                    'aria-labelledby': this.props['aria-labelledby'] || labelId,
                    'aria-required': required || isRequired,
                    role: 'combobox',
                    'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.calculateDescription());
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $a61YJ.default), (0, $iDGsT.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $aFLwO.noop),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: "",
                    "data-testid": testId && "".concat(testId, "-select--input")
                }, ariaAttributes));
                // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
                // Adding `name` to this Input will cause unexpected behavior.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Input, (0, $iDGsT.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    testId: testId,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this5 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder, testId = _this$props9.testId;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Placeholder, (0, $iDGsT.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: $8545d0e8c5603027$var$_objectSpread({
                        id: this.getElementId('placeholder')
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--placeholder")
                    })
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this5.getOptionLabel(opt), "-").concat(_this5.getOptionValue(opt));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(MultiValue, (0, $iDGsT.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: $8545d0e8c5603027$var$_objectSpread($8545d0e8c5603027$var$_objectSpread({
                            onClick: function onClick() {
                                return _this5.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this5.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index, "-remove")
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index, "-remove")
                        }),
                        data: opt,
                        innerProps: $8545d0e8c5603027$var$_objectSpread($8545d0e8c5603027$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index)
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index)
                        })
                    }), _this5.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(SingleValue, (0, $iDGsT.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled,
                    innerProps: {
                        id: this.getElementId('single-value')
                    }
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props0 = this.props, clearControlLabel = _this$props0.clearControlLabel, isDisabled = _this$props0.isDisabled, isLoading = _this$props0.isLoading, spacing = _this$props0.spacing, testId = _this$props0.testId;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = $8545d0e8c5603027$var$_objectSpread({
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd
                }, testId && {
                    'data-testid': "".concat(testId, "-select--clear-indicator")
                });
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ClearIndicator, (0, $iDGsT.default)({
                    clearControlLabel: clearControlLabel
                }, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props1 = this.props, isDisabled = _this$props1.isDisabled, isLoading = _this$props1.isLoading, spacing = _this$props1.spacing, testId = _this$props1.testId;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var isCompact = spacing === 'compact';
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(LoadingIndicator, (0, $iDGsT.default)({
                    "data-testid": testId && "".concat(testId, "-select--loading-indicator")
                }, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, spacing = _this$props10.spacing, testId = _this$props10.testId;
                var isFocused = this.state.isFocused;
                var isCompact = spacing === 'compact';
                var innerProps = $8545d0e8c5603027$var$_objectSpread({
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                }, testId && {
                    'data-testid': "".concat(testId, "-select--dropdown-indicator")
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(DropdownIndicator, (0, $iDGsT.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this6 = this;
                var _this$getComponents6 = this.getComponents(), Group = _this$getComponents6.Group, GroupHeading = _this$getComponents6.GroupHeading, Menu = _this$getComponents6.Menu, MenuList = _this$getComponents6.MenuList, MenuPortal = _this$getComponents6.MenuPortal, LoadingMessage = _this$getComponents6.LoadingMessage, NoOptionsMessage = _this$getComponents6.NoOptionsMessage, Option = _this$getComponents6.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props11 = this.props, captureMenuScroll = _this$props11.captureMenuScroll, inputValue = _this$props11.inputValue, isLoading = _this$props11.isLoading, loadingMessage = _this$props11.loadingMessage, minMenuHeight = _this$props11.minMenuHeight, maxMenuHeight = _this$props11.maxMenuHeight, menuIsOpen = _this$props11.menuIsOpen, menuPlacement = _this$props11.menuPlacement, menuPosition = _this$props11.menuPosition, menuPortalTarget = _this$props11.menuPortalTarget, menuShouldBlockScroll = _this$props11.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props11.menuShouldScrollIntoView, noOptionsMessage = _this$props11.noOptionsMessage, onMenuScrollToTop = _this$props11.onMenuScrollToTop, onMenuScrollToBottom = _this$props11.onMenuScrollToBottom, testId = _this$props11.testId;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id, headingId) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this6.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this6.selectOption(data);
                    };
                    var optionId = "".concat(_this6.getElementId('option'), "-").concat(id);
                    var innerProps = $8545d0e8c5603027$var$_objectSpread({
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        role: _this6.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                        'aria-selected': _this6.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                        // We don't want aria-disabled if it's false. It's just noisy.
                        'aria-disabled': !isDisabled ? undefined : isDisabled,
                        'aria-describedby': headingId
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--option-").concat(id)
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Option, (0, $iDGsT.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this6.getFocusedOptionRef : undefined
                    }), _this6.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) {
                    var items = this.getCategorizedOptions();
                    menuUI = items.map(function(item) {
                        if (item.type === 'group') {
                            var data = item.data, options = item.options, groupIndex = item.index;
                            var groupId = "".concat(_this6.getElementId('group'), "-").concat(groupIndex);
                            var headingId = "".concat(groupId, "-heading");
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Group, (0, $iDGsT.default)({}, commonProps, {
                                key: groupId,
                                data: data,
                                options: options,
                                Heading: GroupHeading,
                                headingProps: $8545d0e8c5603027$var$_objectSpread({
                                    id: headingId,
                                    data: item.data
                                }, testId && {
                                    'data-testid': "".concat(testId, "-select--group-").concat(groupIndex, "-heading")
                                }),
                                label: _this6.formatGroupLabel(item.data)
                            }), item.options.map(function(option) {
                                return render(option, "".concat(groupIndex, "-").concat(option.index), headingId);
                            }));
                        } else if (item.type === 'option') return render(item, "".concat(item.index));
                    });
                } else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(NoOptionsMessage, (0, $iDGsT.default)({}, commonProps, {
                        innerProps: $8545d0e8c5603027$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--no-options")
                        })
                    }), _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4E002.MenuPlacer), (0, $iDGsT.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Menu, (0, $iDGsT.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: $8545d0e8c5603027$var$_objectSpread({
                            onMouseDown: _this6.onMenuMouseDown,
                            onMouseMove: _this6.onMenuMouseMove,
                            id: _this6.props.components.Menu ? _this6.getElementId('listbox') : undefined
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--listbox-container")
                        }),
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iFQY6.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        var _this6$inputRef, _this6$inputRef2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(MenuList, (0, $iDGsT.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this6.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: $8545d0e8c5603027$var$_objectSpread($8545d0e8c5603027$var$_objectSpread($8545d0e8c5603027$var$_objectSpread({
                                role: _this6.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox'
                            }, _this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-labelledby': ((_this6$inputRef = _this6.inputRef) === null || _this6$inputRef === void 0 ? void 0 : _this6$inputRef.id) || _this6.getElementId('input')
                            }), {}, {
                                'aria-multiselectable': !commonProps.isMulti || _this6.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                id: _this6.getElementId('listbox')
                            }, testId && {
                                'data-testid': "".concat(testId, "-select--listbox")
                            }), (0, $Ej25m.isSafari)() && !_this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-describedby': ((_this6$inputRef2 = _this6.inputRef) === null || _this6$inputRef2 === void 0 ? void 0 : _this6$inputRef2.id) || _this6.getElementId('input')
                            }),
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), _this6.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
                            role: "list"
                        }, menuUI) : menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(MenuPortal, (0, $iDGsT.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this7 = this;
                var _this$props12 = this.props, delimiter = _this$props12.delimiter, isDisabled = _this$props12.isDisabled, isMulti = _this$props12.isMulti, required = _this$props12.required, name = _this$props12.name;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $UaMzL.default), {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this7.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this7.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $go0Tl.default), (0, $iDGsT.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "renderMultiselectMessage",
            value: function renderMultiselectMessage() {
                // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
                // Also, since this is rendered onscreen, it should be transtlated automatically.
                var msg = ", multiple selections available, ".concat(this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : '');
                return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
                    id: this.getElementId('multi-message'),
                    hidden: true
                }, msg));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents7 = this.getComponents(), Control = _this$getComponents7.Control, IndicatorsContainer = _this$getComponents7.IndicatorsContainer, SelectContainer = _this$getComponents7.SelectContainer, ValueContainer = _this$getComponents7.ValueContainer;
                var _this$props13 = this.props, className = _this$props13.className, id = _this$props13.id, isDisabled = _this$props13.isDisabled, menuIsOpen = _this$props13.menuIsOpen, isInvalid = _this$props13.isInvalid, testId = _this$props13.testId, _this$props13$appeara = _this$props13.appearance, appearance = _this$props13$appeara === void 0 ? 'default' : _this$props13$appeara, _this$props13$spacing = _this$props13.spacing, spacing = _this$props13$spacing === void 0 ? 'default' : _this$props13$spacing;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(SelectContainer, (0, $iDGsT.default)({}, commonProps, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: className,
                    innerProps: $8545d0e8c5603027$var$_objectSpread({
                        id: id,
                        onKeyDown: this.onKeyDown
                    }, testId && {
                        'data-testid': testId && "".concat(testId, "-select--container")
                    }),
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), commonProps.isMulti && this.renderMultiselectMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Control, (0, $iDGsT.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: $8545d0e8c5603027$var$_objectSpread({
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--control")
                    }),
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ValueContainer, (0, $iDGsT.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isCompact: isCompact,
                    innerProps: $8545d0e8c5603027$var$_objectSpread($8545d0e8c5603027$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--value-container")
                    }), commonProps.isMulti && commonProps.hasValue && !(0, $Ej25m.isAppleDevice)() && {
                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                        // DST Accessibility.
                        role: 'application'
                    })
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(IndicatorsContainer, (0, $iDGsT.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    innerProps: $8545d0e8c5603027$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--indicators-container")
                    })
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $gFMof.NotifyOpenLayerObserver), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $aFLwO.cleanValue)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $8545d0e8c5603027$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $8545d0e8c5603027$var$buildFocusableOptionsWithIds($8545d0e8c5603027$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $8545d0e8c5603027$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $8545d0e8c5603027$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $8545d0e8c5603027$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $aFLwO.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return $8545d0e8c5603027$var$_objectSpread($8545d0e8c5603027$var$_objectSpread($8545d0e8c5603027$var$_objectSpread({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
}((0, $1oC0p.Component));
(0, $gp1ED.default)($8545d0e8c5603027$export$2e2bcd8739ae039, "defaultProps", $8545d0e8c5603027$export$9c21a3269931e1e6);

});
parcelRegister("7vSNf", function(module, exports) {
function $5785ee7596d0a2e4$export$2e2bcd8739ae039(r) {
    throw new TypeError('"' + r + '" is read-only');
}

});

parcelRegister("5wtQz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $405717e03cb8a3a9$export$2e2bcd8739ae039; });
function $405717e03cb8a3a9$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $405717e03cb8a3a9$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $405717e03cb8a3a9$export$2e2bcd8739ae039(o);
}

});

parcelRegister("1L9xr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1481945735bd957f$export$2e2bcd8739ae039; });
function $1481945735bd957f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("gk4W6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $be2257d354d51d77$export$2e2bcd8739ae039; });

var $jsUR7 = parcelRequire("jsUR7");
function $be2257d354d51d77$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $jsUR7.default)(o.key), o);
    }
}
function $be2257d354d51d77$export$2e2bcd8739ae039(e, r, t) {
    return r && $be2257d354d51d77$var$_defineProperties(e.prototype, r), t && $be2257d354d51d77$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("jsUR7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e2bcbc348911fb95$export$2e2bcd8739ae039; });

var $5wtQz = parcelRequire("5wtQz");

var $1Hz38 = parcelRequire("1Hz38");
function $e2bcbc348911fb95$export$2e2bcd8739ae039(t) {
    var i = (0, $1Hz38.default)(t, "string");
    return "symbol" == (0, $5wtQz.default)(i) ? i : i + "";
}

});
parcelRegister("1Hz38", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $13d4feb927398a24$export$2e2bcd8739ae039; });

var $5wtQz = parcelRequire("5wtQz");
function $13d4feb927398a24$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $5wtQz.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $5wtQz.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("hz9hK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cc9ce8640170901f$export$2e2bcd8739ae039; });

var $5wtQz = parcelRequire("5wtQz");

var $jIC14 = parcelRequire("jIC14");
function $cc9ce8640170901f$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5wtQz.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $jIC14.default)(t);
}

});
parcelRegister("jIC14", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e5af9d9aa249b87d$export$2e2bcd8739ae039; });
function $e5af9d9aa249b87d$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("gWRUU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c56be2e1f363bffa$export$2e2bcd8739ae039; });
function $c56be2e1f363bffa$export$2e2bcd8739ae039(t) {
    return $c56be2e1f363bffa$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $c56be2e1f363bffa$export$2e2bcd8739ae039(t);
}

});

parcelRegister("9gsna", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6beb9dea9494ea25$export$2e2bcd8739ae039; });

var $aa84f = parcelRequire("aa84f");
function $6beb9dea9494ea25$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $aa84f.default)(t, e);
}

});
parcelRegister("aa84f", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $76611896f6a3fedc$export$2e2bcd8739ae039; });
function $76611896f6a3fedc$export$2e2bcd8739ae039(t, e) {
    return $76611896f6a3fedc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $76611896f6a3fedc$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("gp1ED", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bf1043a7a1e13b58$export$2e2bcd8739ae039; });

var $jsUR7 = parcelRequire("jsUR7");
function $bf1043a7a1e13b58$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $jsUR7.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("c5fcX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8cc1bfaada31087c$export$2e2bcd8739ae039; });

var $1LkGe = parcelRequire("1LkGe");

var $bKWxQ = parcelRequire("bKWxQ");

var $beyZC = parcelRequire("beyZC");

var $jZuAm = parcelRequire("jZuAm");
function $8cc1bfaada31087c$export$2e2bcd8739ae039(r) {
    return (0, $1LkGe.default)(r) || (0, $bKWxQ.default)(r) || (0, $beyZC.default)(r) || (0, $jZuAm.default)();
}

});
parcelRegister("1LkGe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $148a38e7a3ac7462$export$2e2bcd8739ae039; });

var $d3LyR = parcelRequire("d3LyR");
function $148a38e7a3ac7462$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $d3LyR.default)(r);
}

});
parcelRegister("d3LyR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $982072d82949e1c7$export$2e2bcd8739ae039; });
function $982072d82949e1c7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("bKWxQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $02357126b9cf7540$export$2e2bcd8739ae039; });
function $02357126b9cf7540$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("beyZC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $82dc25614d073844$export$2e2bcd8739ae039; });

var $d3LyR = parcelRequire("d3LyR");
function $82dc25614d073844$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $d3LyR.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $d3LyR.default)(r, a) : void 0;
    }
}

});

parcelRegister("jZuAm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e8db7078e5660596$export$2e2bcd8739ae039; });
function $e8db7078e5660596$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("Ej25m", function(module, exports) {
$parcel$export(module.exports, "isSafari", function () { return $07928006cfe48522$export$95df08bae54cb4df; });
$parcel$export(module.exports, "isAppleDevice", function () { return $07928006cfe48522$export$e1865c3bedcd822b; });
function $07928006cfe48522$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $07928006cfe48522$var$isIPhone() {
    return $07928006cfe48522$var$testPlatform(/^iPhone/i);
}
function $07928006cfe48522$var$isMac() {
    return $07928006cfe48522$var$testPlatform(/^Mac/i);
}
function $07928006cfe48522$var$isIPad() {
    return $07928006cfe48522$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $07928006cfe48522$var$isMac() && navigator.maxTouchPoints > 1;
}
function $07928006cfe48522$var$isIOS() {
    return $07928006cfe48522$var$isIPhone() || $07928006cfe48522$var$isIPad();
}
function $07928006cfe48522$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $07928006cfe48522$export$e1865c3bedcd822b() {
    return $07928006cfe48522$var$isMac() || $07928006cfe48522$var$isIOS();
}

});

parcelRegister("jfUrB", function(module, exports) {
$parcel$export(module.exports, "formatGroupLabel", function () { return $e04b33b037cf2daf$export$f4da216a6ca54656; });
$parcel$export(module.exports, "getOptionLabel", function () { return $e04b33b037cf2daf$export$dac6ace3020563ca; });
$parcel$export(module.exports, "getOptionValue", function () { return $e04b33b037cf2daf$export$40be908210c5a79c; });
$parcel$export(module.exports, "isOptionDisabled", function () { return $e04b33b037cf2daf$export$56bd0c8d90db075; });
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $e04b33b037cf2daf$export$f4da216a6ca54656 = function formatGroupLabel(group) {
    return group.label;
};
var $e04b33b037cf2daf$export$dac6ace3020563ca = function getOptionLabel(option) {
    return option.label;
};
var $e04b33b037cf2daf$export$40be908210c5a79c = function getOptionValue(option) {
    return option.value;
};
var $e04b33b037cf2daf$export$56bd0c8d90db075 = function isOptionDisabled(option) {
    return !!option.isDisabled;
};

});

parcelRegister("4lRXd", function(module, exports) {
$parcel$export(module.exports, "components", function () { return $32b2f9c1cc1b285e$export$9b5ac10f59f76296; });
$parcel$export(module.exports, "defaultComponents", function () { return $32b2f9c1cc1b285e$export$71abc632aa29e6fe; });

var $gp1ED = parcelRequire("gp1ED");

var $4jkgc = parcelRequire("4jkgc");

var $gm3od = parcelRequire("gm3od");

var $bY2JO = parcelRequire("bY2JO");

var $czEWC = parcelRequire("czEWC");

var $6Kvjy = parcelRequire("6Kvjy");

var $4E002 = parcelRequire("4E002");

var $31ssg = parcelRequire("31ssg");

var $c9hM5 = parcelRequire("c9hM5");

var $iX5p5 = parcelRequire("iX5p5");

var $kf90p = parcelRequire("kf90p");
function $32b2f9c1cc1b285e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $32b2f9c1cc1b285e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $32b2f9c1cc1b285e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gp1ED.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $32b2f9c1cc1b285e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $32b2f9c1cc1b285e$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $czEWC.ClearIndicator),
    Control: (0, $gm3od.default),
    DropdownIndicator: (0, $czEWC.DropdownIndicator),
    Group: (0, $bY2JO.default),
    GroupHeading: (0, $bY2JO.GroupHeading),
    IndicatorsContainer: (0, $4jkgc.IndicatorsContainer),
    Input: (0, $6Kvjy.default),
    LoadingIndicator: (0, $czEWC.LoadingIndicator),
    Menu: (0, $4E002.default),
    MenuList: (0, $4E002.MenuList),
    MenuPortal: (0, $4E002.MenuPortal),
    LoadingMessage: (0, $4E002.LoadingMessage),
    NoOptionsMessage: (0, $4E002.NoOptionsMessage),
    MultiValue: (0, $31ssg.default),
    MultiValueContainer: (0, $31ssg.MultiValueContainer),
    MultiValueLabel: (0, $31ssg.MultiValueLabel),
    MultiValueRemove: (0, $31ssg.MultiValueRemove),
    Option: (0, $c9hM5.default),
    Placeholder: (0, $iX5p5.default),
    SelectContainer: (0, $4jkgc.SelectContainer),
    SingleValue: (0, $kf90p.default),
    ValueContainer: (0, $4jkgc.ValueContainer)
};
var $32b2f9c1cc1b285e$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $32b2f9c1cc1b285e$var$_objectSpread($32b2f9c1cc1b285e$var$_objectSpread({}, $32b2f9c1cc1b285e$export$9b5ac10f59f76296), props.components);
};

});
parcelRegister("4jkgc", function(module, exports) {
$parcel$export(module.exports, "containerCSS", function () { return $3238a70819049e2a$export$949392aeaf7d2e3a; });
$parcel$export(module.exports, "SelectContainer", function () { return $3238a70819049e2a$export$446eebadefe1123b; });
$parcel$export(module.exports, "valueContainerCSS", function () { return $3238a70819049e2a$export$47aec73c7aa6b9aa; });
$parcel$export(module.exports, "ValueContainer", function () { return $3238a70819049e2a$export$4dc9f58ad9a1a000; });
$parcel$export(module.exports, "indicatorsContainerCSS", function () { return $3238a70819049e2a$export$9d74e3c8b5868ad7; });
$parcel$export(module.exports, "IndicatorsContainer", function () { return $3238a70819049e2a$export$d0ffd7e649cab6f; });
/* containers.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iDGsT = parcelRequire("iDGsT");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $8wxT4 = parcelRequire("8wxT4");

var $39c3M = parcelRequire("39c3M");

var $aFLwO = parcelRequire("aFLwO");
var $3238a70819049e2a$export$949392aeaf7d2e3a = function containerCSS() {
    return {};
};
var $3238a70819049e2a$var$containerStyles = {
    default: "_11c82smr _kqswh2mm _lcxv1rj4",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf",
    ff_safari_input_fix: "_11c81ixg _1tn22smr"
};
var $3238a70819049e2a$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $aFLwO.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lyHO0.default)([
            $3238a70819049e2a$var$containerStyles.default,
            isRtl && $3238a70819049e2a$var$containerStyles.rtl,
            isDisabled && $3238a70819049e2a$var$containerStyles.disabled,
            (0, $39c3M.fg)('platform_design_system_team_safari_input_fix') && $3238a70819049e2a$var$containerStyles.ff_safari_input_fix,
            (0, $8wxT4.cx)(className, xcss, '-container')
        ]),
        style: css
    }, innerProps), children);
};
var $3238a70819049e2a$export$47aec73c7aa6b9aa = function valueContainerCSS() {
    return {};
};
var $3238a70819049e2a$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qze3t _u5f312x7 _n3tdze3t _19bv12x7"
};
var $3238a70819049e2a$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps2 = (0, $aFLwO.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lyHO0.default)([
            $3238a70819049e2a$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $3238a70819049e2a$var$valueContainerStyles.flex,
            isCompact && $3238a70819049e2a$var$valueContainerStyles.compact,
            (0, $8wxT4.cx)(className, xcss, '-ValueContainer')
        ]),
        style: css
    }, innerProps), children);
};
var $3238a70819049e2a$export$9d74e3c8b5868ad7 = function indicatorsContainerCSS() {
    return {};
};
var $3238a70819049e2a$var$indicatorContainerStyles = null;
var $3238a70819049e2a$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps3 = (0, $aFLwO.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lyHO0.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $8wxT4.cx)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), children);
};

});
parcelRegister("lyHO0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fb1ec0d138662ce8$export$2e2bcd8739ae039; });
const $fb1ec0d138662ce8$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $fb1ec0d138662ce8$var$ATOMIC_GROUP_LENGTH = 5;
function $fb1ec0d138662ce8$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $fb1ec0d138662ce8$var$UNDERSCORE_UNICODE ? $fb1ec0d138662ce8$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("8wxT4", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $634b9934b389b5e5$export$a274e22fb40f762e; });

var $lyHO0 = parcelRequire("lyHO0");
const $634b9934b389b5e5$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $lyHO0.default)(actualStyles);
};

});

parcelRegister("aFLwO", function(module, exports) {
$parcel$export(module.exports, "noop", function () { return $7c5299d8e30a4a1a$export$8793edee2d425525; });
$parcel$export(module.exports, "classNames", function () { return $7c5299d8e30a4a1a$export$ce4ab0c55987d1ff; });
$parcel$export(module.exports, "cleanValue", function () { return $7c5299d8e30a4a1a$export$33f062f47f21a01; });
$parcel$export(module.exports, "cleanCommonProps", function () { return $7c5299d8e30a4a1a$export$8e9fd4287627890c; });
$parcel$export(module.exports, "getStyleProps", function () { return $7c5299d8e30a4a1a$export$26417cabd806a658; });
$parcel$export(module.exports, "handleInputChange", function () { return $7c5299d8e30a4a1a$export$2096bae78ecda911; });
$parcel$export(module.exports, "isDocumentElement", function () { return $7c5299d8e30a4a1a$export$d8a62a489b442872; });
$parcel$export(module.exports, "normalizedHeight", function () { return $7c5299d8e30a4a1a$export$2e0654fad740d2e4; });
$parcel$export(module.exports, "getScrollTop", function () { return $7c5299d8e30a4a1a$export$c4a223a8ba9e4ea5; });
$parcel$export(module.exports, "scrollTo", function () { return $7c5299d8e30a4a1a$export$3f99968195accfaf; });
$parcel$export(module.exports, "getScrollParent", function () { return $7c5299d8e30a4a1a$export$cfa2225e87938781; });
$parcel$export(module.exports, "animatedScrollTo", function () { return $7c5299d8e30a4a1a$export$858c30343199f3af; });
$parcel$export(module.exports, "scrollIntoView", function () { return $7c5299d8e30a4a1a$export$53a0910f038337bd; });
$parcel$export(module.exports, "getBoundingClientObj", function () { return $7c5299d8e30a4a1a$export$7807c2a424c2f6d1; });
$parcel$export(module.exports, "isTouchCapable", function () { return $7c5299d8e30a4a1a$export$56963d77dbffdde7; });
$parcel$export(module.exports, "isMobileDevice", function () { return $7c5299d8e30a4a1a$export$44f917bf91becd01; });
$parcel$export(module.exports, "supportsPassiveEvents", function () { return $7c5299d8e30a4a1a$export$b0622a6911dbeaf5; });
$parcel$export(module.exports, "notNullish", function () { return $7c5299d8e30a4a1a$export$aedb69ff3e31596c; });
$parcel$export(module.exports, "valueTernary", function () { return $7c5299d8e30a4a1a$export$40fb9515c784cc3b; });
$parcel$export(module.exports, "singleValueAsValue", function () { return $7c5299d8e30a4a1a$export$dea4763e29237f4c; });
$parcel$export(module.exports, "multiValueAsValue", function () { return $7c5299d8e30a4a1a$export$d1ca752ec761b95b; });
$parcel$export(module.exports, "removeProps", function () { return $7c5299d8e30a4a1a$export$4213b25a1c4e877; });
$parcel$export(module.exports, "filterUnsupportedSelectors", function () { return $7c5299d8e30a4a1a$export$bf2eda47afa5f369; });

var $6uJws = parcelRequire("6uJws");

var $gp1ED = parcelRequire("gp1ED");

var $cogXd = parcelRequire("cogXd");

var $5wtQz = parcelRequire("5wtQz");
var $7c5299d8e30a4a1a$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $7c5299d8e30a4a1a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7c5299d8e30a4a1a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7c5299d8e30a4a1a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gp1ED.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7c5299d8e30a4a1a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7c5299d8e30a4a1a$export$8793edee2d425525 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $7c5299d8e30a4a1a$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $7c5299d8e30a4a1a$export$ce4ab0c55987d1ff(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($7c5299d8e30a4a1a$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
var $7c5299d8e30a4a1a$export$33f062f47f21a01 = function cleanValue(value) {
    if ($7c5299d8e30a4a1a$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5wtQz.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
var $7c5299d8e30a4a1a$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, $cogXd.default)(props, $7c5299d8e30a4a1a$var$_excluded);
    return $7c5299d8e30a4a1a$var$_objectSpread({}, innerProps);
};
var $7c5299d8e30a4a1a$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
function $7c5299d8e30a4a1a$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $7c5299d8e30a4a1a$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $7c5299d8e30a4a1a$export$2e0654fad740d2e4(el) {
    if ($7c5299d8e30a4a1a$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $7c5299d8e30a4a1a$export$c4a223a8ba9e4ea5(el) {
    if ($7c5299d8e30a4a1a$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $7c5299d8e30a4a1a$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($7c5299d8e30a4a1a$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $7c5299d8e30a4a1a$export$cfa2225e87938781(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $7c5299d8e30a4a1a$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $7c5299d8e30a4a1a$export$858c30343199f3af(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $7c5299d8e30a4a1a$export$8793edee2d425525;
    var start = $7c5299d8e30a4a1a$export$c4a223a8ba9e4ea5(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $7c5299d8e30a4a1a$var$easeOutCubic(currentTime, start, change, duration);
        $7c5299d8e30a4a1a$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $7c5299d8e30a4a1a$export$53a0910f038337bd(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $7c5299d8e30a4a1a$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $7c5299d8e30a4a1a$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $7c5299d8e30a4a1a$export$7807c2a424c2f6d1(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $7c5299d8e30a4a1a$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $7c5299d8e30a4a1a$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $7c5299d8e30a4a1a$var$passiveOptionAccessed = false;
var $7c5299d8e30a4a1a$var$options = {
    get passive () {
        return $7c5299d8e30a4a1a$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $7c5299d8e30a4a1a$var$w = typeof window !== 'undefined' ? window : {};
if ($7c5299d8e30a4a1a$var$w.addEventListener && $7c5299d8e30a4a1a$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $7c5299d8e30a4a1a$var$w.addEventListener('p', $7c5299d8e30a4a1a$export$8793edee2d425525, $7c5299d8e30a4a1a$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $7c5299d8e30a4a1a$var$w.removeEventListener('p', $7c5299d8e30a4a1a$export$8793edee2d425525, false);
}
var $7c5299d8e30a4a1a$export$b0622a6911dbeaf5 = $7c5299d8e30a4a1a$var$passiveOptionAccessed;
function $7c5299d8e30a4a1a$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $7c5299d8e30a4a1a$var$isArray(arg) {
    return Array.isArray(arg);
}
function $7c5299d8e30a4a1a$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $7c5299d8e30a4a1a$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $7c5299d8e30a4a1a$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
var $7c5299d8e30a4a1a$export$4213b25a1c4e877 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $6uJws.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $6uJws.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $7c5299d8e30a4a1a$export$bf2eda47afa5f369 = function filterUnsupportedSelectors(styles) {
    var unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce(function(filteredStyles, key) {
        if (!unsupportedSelectors.some(function(selector) {
            return key.includes(selector);
        })) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};

});
parcelRegister("6uJws", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4ba8db3d8541c5e7$export$2e2bcd8739ae039; });

var $4t6ER = parcelRequire("4t6ER");

var $9HEvp = parcelRequire("9HEvp");

var $beyZC = parcelRequire("beyZC");

var $3xg9w = parcelRequire("3xg9w");
function $4ba8db3d8541c5e7$export$2e2bcd8739ae039(r, e) {
    return (0, $4t6ER.default)(r) || (0, $9HEvp.default)(r, e) || (0, $beyZC.default)(r, e) || (0, $3xg9w.default)();
}

});
parcelRegister("4t6ER", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $340f08fcc603dde9$export$2e2bcd8739ae039; });
function $340f08fcc603dde9$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("9HEvp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $71078cc27094bf9e$export$2e2bcd8739ae039; });
function $71078cc27094bf9e$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("3xg9w", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2930fbc0658b2c77$export$2e2bcd8739ae039; });
function $2930fbc0658b2c77$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("cogXd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9054e0a7f32c9cb5$export$2e2bcd8739ae039; });

var $aavZu = parcelRequire("aavZu");
function $9054e0a7f32c9cb5$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $aavZu.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("aavZu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7673a73c288a1b1b$export$2e2bcd8739ae039; });
function $7673a73c288a1b1b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});




parcelRegister("gm3od", function(module, exports) {
$parcel$export(module.exports, "css", function () { return $be81547dcaeb2cfa$export$dbf350e5966cf602; });
$parcel$export(module.exports, "default", function () { return $be81547dcaeb2cfa$export$2e2bcd8739ae039; });
/* control.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iDGsT = parcelRequire("iDGsT");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $8wxT4 = parcelRequire("8wxT4");

var $aFLwO = parcelRequire("aFLwO");
var $be81547dcaeb2cfa$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6d1elr _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _15peftgi _1ke8ftgi _jaboglyw _1u6l1bml _4cvx1elr _123byq51 _d0altlke _irr31d5g _1ogl1caj",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsq049",
    disabled: "_1h6dsyzs _lcxvglyw _bfhksyzs _1u6llkwx",
    focused: "_1h6d1p6i _bfhkr01l _16qsq049 _1u6lq049 _4cvx1p6i _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $be81547dcaeb2cfa$export$dbf350e5966cf602 = function css() {
    return {};
};
var $be81547dcaeb2cfa$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $aFLwO.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        ref: innerRef,
        className: (0, $lyHO0.default)([
            $be81547dcaeb2cfa$var$styles.default,
            isDisabled && $be81547dcaeb2cfa$var$styles.disabled,
            isInvalid && $be81547dcaeb2cfa$var$styles.invalid,
            isCompact && $be81547dcaeb2cfa$var$styles.compact,
            appearance === 'subtle' && $be81547dcaeb2cfa$var$styles.subtle,
            appearance === 'subtle' && isFocused && $be81547dcaeb2cfa$var$styles.subtleFocused,
            isFocused && $be81547dcaeb2cfa$var$styles.focused,
            appearance === 'none' && $be81547dcaeb2cfa$var$styles.none,
            (0, $8wxT4.cx)(className, xcss, '-control')
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be81547dcaeb2cfa$export$2e2bcd8739ae039 = $be81547dcaeb2cfa$var$Control;

});

parcelRegister("bY2JO", function(module, exports) {
$parcel$export(module.exports, "groupCSS", function () { return $8b676bff2f894d46$export$b6794329c1460634; });
$parcel$export(module.exports, "groupHeadingCSS", function () { return $8b676bff2f894d46$export$e5a7fbb542efcb7d; });
$parcel$export(module.exports, "GroupHeading", function () { return $8b676bff2f894d46$export$85c8b41a3cd87edc; });
$parcel$export(module.exports, "default", function () { return $8b676bff2f894d46$export$2e2bcd8739ae039; });
/* group.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $cogXd = parcelRequire("cogXd");

var $iDGsT = parcelRequire("iDGsT");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $8wxT4 = parcelRequire("8wxT4");

var $aFLwO = parcelRequire("aFLwO");
var $8b676bff2f894d46$var$_excluded = [
    "data"
];
var $8b676bff2f894d46$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
var $8b676bff2f894d46$export$b6794329c1460634 = function groupCSS() {
    return {};
};
var $8b676bff2f894d46$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $aFLwO.getStyleProps)(props, 'group', {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lyHO0.default)([
            $8b676bff2f894d46$var$styles.root,
            (0, $8wxT4.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ])
    }), label && /*#__PURE__*/ $1oC0p.createElement(Heading, (0, $iDGsT.default)({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $1oC0p.createElement("div", null, children));
};
var $8b676bff2f894d46$var$headingStyles = null;
var $8b676bff2f894d46$export$e5a7fbb542efcb7d = function groupHeadingCSS() {
    return {};
};
var $8b676bff2f894d46$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $aFLwO.cleanCommonProps)(props), data = _cleanCommonProps.data, innerProps = (0, $cogXd.default)(_cleanCommonProps, $8b676bff2f894d46$var$_excluded);
    var _getStyleProps2 = (0, $aFLwO.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lyHO0.default)([
            "_11c81o8v _1e0c1ule _syaz1gjq _80om73ad _k48pmoej _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $8wxT4.cx)(className, xcss, '-group')
        ]),
        style: css
    }, innerProps));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8b676bff2f894d46$export$2e2bcd8739ae039 = $8b676bff2f894d46$var$Group;

});

parcelRegister("czEWC", function(module, exports) {
$parcel$export(module.exports, "dropdownIndicatorCSS", function () { return $927883a68295eb02$export$e1687335805e1230; });
$parcel$export(module.exports, "DropdownIndicator", function () { return $927883a68295eb02$export$ec98719d3db7f2e4; });
$parcel$export(module.exports, "clearIndicatorCSS", function () { return $927883a68295eb02$export$9c0419fd944c1def; });
$parcel$export(module.exports, "ClearIndicator", function () { return $927883a68295eb02$export$ecf9cf59142dd54a; });
$parcel$export(module.exports, "loadingIndicatorCSS", function () { return $927883a68295eb02$export$1d3f24cde248e6b5; });
$parcel$export(module.exports, "LoadingIndicator", function () { return $927883a68295eb02$export$7c20be4c1d342248; });
/* indicators.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $gp1ED = parcelRequire("gp1ED");

var $cogXd = parcelRequire("cogXd");

var $iDGsT = parcelRequire("iDGsT");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $8wxT4 = parcelRequire("8wxT4");

var $25ptt = parcelRequire("25ptt");

var $5ncUp = parcelRequire("5ncUp");

var $hth5J = parcelRequire("hth5J");
var $1fq6V = parcelRequire("1fq6V");

var $eCBjk = parcelRequire("eCBjk");

var $aFLwO = parcelRequire("aFLwO");
var $927883a68295eb02$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $927883a68295eb02$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $927883a68295eb02$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $927883a68295eb02$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gp1ED.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $927883a68295eb02$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $927883a68295eb02$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
var $927883a68295eb02$var$dropdownWrapperStyles = {
    root: "_ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7"
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $927883a68295eb02$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1gjq _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf",
    disabled: "_syaz1lh4"
};
var $927883a68295eb02$export$e1687335805e1230 = function dropdownIndicatorCSS() {
    return {};
};
var $927883a68295eb02$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var innerProps = props.innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $aFLwO.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lyHO0.default)([
            $927883a68295eb02$var$dropdownStyles.default,
            isDisabled && $927883a68295eb02$var$dropdownStyles.disabled,
            isCompact && $927883a68295eb02$var$dropdownStyles.compact,
            (0, $8wxT4.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), children ? children : /*#__PURE__*/ $1oC0p.createElement((0, $hth5J.default), {
        as: "span",
        xcss: $927883a68295eb02$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($25ptt))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)",
        size: "small"
    })));
};
var $927883a68295eb02$export$9c0419fd944c1def = function clearIndicatorCSS() {
    return {};
};
var $927883a68295eb02$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz131l _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf"
};
var $927883a68295eb02$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? 'clear' : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps2 = (0, $aFLwO.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lyHO0.default)([
            $927883a68295eb02$var$clearIndicatorStyles.default,
            isCompact && $927883a68295eb02$var$clearIndicatorStyles.compact,
            (0, $8wxT4.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), /*#__PURE__*/ $1oC0p.createElement((0, $1fq6V.default), {
        xcss: $927883a68295eb02$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ncUp))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)",
        size: "small"
    })));
};
var $927883a68295eb02$export$1d3f24cde248e6b5 = function loadingIndicatorCSS() {
    return {};
};
var $927883a68295eb02$var$loadingIndicatorStyles = {
    default: "_ca0q12x7 _u5f3u2gc _n3td12x7 _19bvu2gc",
    compact: "_ca0qidpf _n3tdidpf"
};
var $927883a68295eb02$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, $cogXd.default)(_ref, $927883a68295eb02$var$_excluded);
    var _getStyleProps3 = (0, $aFLwO.getStyleProps)($927883a68295eb02$var$_objectSpread($927883a68295eb02$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lyHO0.default)([
            $927883a68295eb02$var$loadingIndicatorStyles.default,
            isCompact && $927883a68295eb02$var$loadingIndicatorStyles.compact,
            (0, $8wxT4.cx)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), /*#__PURE__*/ $1oC0p.createElement((0, $eCBjk.default), {
        size: "small"
    }));
};

});
parcelRegister("25ptt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d03862cd3f81bd2eb2145cf11d082237>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $184fcf1ad4ed520c$var$_react = $184fcf1ad4ed520c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $184fcf1ad4ed520c$var$_chevronDown = $184fcf1ad4ed520c$var$_interopRequireDefault((parcelRequire("2mlye")));

var $184fcf1ad4ed520c$var$_chevronDown2 = $184fcf1ad4ed520c$var$_interopRequireDefault((parcelRequire("013oa")));
function $184fcf1ad4ed520c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $184fcf1ad4ed520c$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $184fcf1ad4ed520c$var$_react.default.createElement($184fcf1ad4ed520c$var$_chevronDown.default, Object.assign({
        name: "ChevronDownIcon",
        LEGACY_fallbackIcon: $184fcf1ad4ed520c$var$_chevronDown2.default
    }, props));
$184fcf1ad4ed520c$var$ChevronDownIcon.displayName = 'ChevronDownIconMigration';
var $184fcf1ad4ed520c$var$_default = module.exports.default = $184fcf1ad4ed520c$var$ChevronDownIcon;

});
parcelRegister("2mlye", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b7e5a79226b283d$var$_react = $1b7e5a79226b283d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1b7e5a79226b283d$var$_baseNew = $1b7e5a79226b283d$var$_interopRequireDefault((parcelRequire("gxdRn")));
function $1b7e5a79226b283d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1b7e5a79226b283d$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $1b7e5a79226b283d$var$_react.default.createElement($1b7e5a79226b283d$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$1b7e5a79226b283d$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $1b7e5a79226b283d$var$_default = module.exports.default = $1b7e5a79226b283d$var$ChevronDownIcon;

});
parcelRegister("gxdRn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("g9bAE")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("g9bAE")).Icon; });

var $g9bAE = parcelRequire("g9bAE");

});
parcelRegister("g9bAE", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $bc167a2b8004b679$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $bc167a2b8004b679$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $39c3M = parcelRequire("39c3M");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $bc167a2b8004b679$var$svgStyles = null;
var $bc167a2b8004b679$var$iconStyles = null;
var $bc167a2b8004b679$var$utilityIconStyles = null;
var $bc167a2b8004b679$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $bc167a2b8004b679$var$baseHcmStyles = null;
var $bc167a2b8004b679$var$scaleSize = null;
var $bc167a2b8004b679$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $bc167a2b8004b679$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $bc167a2b8004b679$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $bc167a2b8004b679$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $bc167a2b8004b679$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $bc167a2b8004b679$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $39c3M.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $1oC0p.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $bc167a2b8004b679$var$baseSizeMap[type];
    var viewBoxPadding = $bc167a2b8004b679$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $lyHO0.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $lyHO0.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $bc167a2b8004b679$var$utilSizes[spacing] : size === 'small' ? $bc167a2b8004b679$var$coreSizeSmall[spacing] : $bc167a2b8004b679$var$coreSizeMedium[spacing]
        ])
    }));
});
var $bc167a2b8004b679$export$2e2bcd8739ae039 = $bc167a2b8004b679$export$f04a61298a47a40f;

});



parcelRegister("013oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0032b911556b62ba$var$_react = $0032b911556b62ba$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $djIFz = parcelRequire("djIFz");
function $0032b911556b62ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0032b911556b62ba$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $0032b911556b62ba$var$_react.default.createElement($djIFz.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props));
$0032b911556b62ba$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $0032b911556b62ba$var$_default = module.exports.default = $0032b911556b62ba$var$ChevronDownIcon;

});
parcelRegister("djIFz", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $9b1fb3298d30e98c$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iDGsT = parcelRequire("iDGsT");

var $gp1ED = parcelRequire("gp1ED");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");
function $9b1fb3298d30e98c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9b1fb3298d30e98c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9b1fb3298d30e98c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gp1ED.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9b1fb3298d30e98c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $9b1fb3298d30e98c$var$iconStyles = null;
var $9b1fb3298d30e98c$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $9b1fb3298d30e98c$var$baseHcmStyles = null;
var $9b1fb3298d30e98c$var$primaryEqualsSecondaryHcmStyles = null;
var $9b1fb3298d30e98c$var$secondaryTransparentHcmStyles = null;
var $9b1fb3298d30e98c$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $1oC0p.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $1oC0p.createElement("span", (0, $iDGsT.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $9b1fb3298d30e98c$var$_objectSpread($9b1fb3298d30e98c$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $lyHO0.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $9b1fb3298d30e98c$var$sizeStyles[size]
        ])
    }));
});
var $9b1fb3298d30e98c$export$2e2bcd8739ae039 = $9b1fb3298d30e98c$export$f04a61298a47a40f;

});



parcelRegister("5ncUp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c64b1bb7f30549dd379d26abd8d4a76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e991d296ebd2c74$var$_react = $3e991d296ebd2c74$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3e991d296ebd2c74$var$_crossCircle = $3e991d296ebd2c74$var$_interopRequireDefault((parcelRequire("7LW1k")));

var $3e991d296ebd2c74$var$_selectClear = $3e991d296ebd2c74$var$_interopRequireDefault((parcelRequire("4cJk8")));
function $3e991d296ebd2c74$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e991d296ebd2c74$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $3e991d296ebd2c74$var$_react.default.createElement($3e991d296ebd2c74$var$_crossCircle.default, Object.assign({
        name: "CrossCircleIcon",
        LEGACY_fallbackIcon: $3e991d296ebd2c74$var$_selectClear.default
    }, props));
$3e991d296ebd2c74$var$CrossCircleIcon.displayName = 'CrossCircleIconMigration';
var $3e991d296ebd2c74$var$_default = module.exports.default = $3e991d296ebd2c74$var$CrossCircleIcon;

});
parcelRegister("7LW1k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a89edd219dbd29a$var$_react = $5a89edd219dbd29a$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5a89edd219dbd29a$var$_baseNew = $5a89edd219dbd29a$var$_interopRequireDefault((parcelRequire("gxdRn")));
function $5a89edd219dbd29a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a89edd219dbd29a$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $5a89edd219dbd29a$var$_react.default.createElement($5a89edd219dbd29a$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$5a89edd219dbd29a$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $5a89edd219dbd29a$var$_default = module.exports.default = $5a89edd219dbd29a$var$CrossCircleIcon;

});

parcelRegister("4cJk8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30fb70bfd2e629bd$var$_react = $30fb70bfd2e629bd$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $djIFz = parcelRequire("djIFz");
function $30fb70bfd2e629bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $30fb70bfd2e629bd$var$SelectClearIcon = (props)=>/*#__PURE__*/ $30fb70bfd2e629bd$var$_react.default.createElement($djIFz.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props));
$30fb70bfd2e629bd$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $30fb70bfd2e629bd$var$_default = module.exports.default = $30fb70bfd2e629bd$var$SelectClearIcon;

});


parcelRegister("hth5J", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cb82671a4e471a33$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iDGsT = parcelRequire("iDGsT");

var $cogXd = parcelRequire("cogXd");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $1zzQ7 = parcelRequire("1zzQ7");

var $1gYOW = parcelRequire("1gYOW");
var $cb82671a4e471a33$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $cb82671a4e471a33$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $cb82671a4e471a33$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $lyHO0.default)([
            $cb82671a4e471a33$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $cb82671a4e471a33$var$Inline = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, $cogXd.default)(_ref2, $cb82671a4e471a33$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $1oC0p.createElement($cb82671a4e471a33$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1oC0p.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $1oC0p.createElement((0, $1gYOW.default), (0, $iDGsT.default)({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $1zzQ7.cx)(grow === 'hug' && $cb82671a4e471a33$var$styles.hug, grow === 'fill' && $cb82671a4e471a33$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$cb82671a4e471a33$var$Inline.displayName = 'Inline';
var $cb82671a4e471a33$export$2e2bcd8739ae039 = $cb82671a4e471a33$var$Inline;

});
parcelRegister("1zzQ7", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $1254dc512f145030$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("1oC0p");


var $3dnb3 = parcelRequire("3dnb3");
var $1254dc512f145030$var$_createStrictAPI = (0, $3dnb3.createStrictAPI)(), $1254dc512f145030$var$XCSSProp = $1254dc512f145030$var$_createStrictAPI.XCSSProp, $1254dc512f145030$export$dbf350e5966cf602 = $1254dc512f145030$var$_createStrictAPI.css, $1254dc512f145030$export$eb1ecd84a24ee424 = $1254dc512f145030$var$_createStrictAPI.cssMap, $1254dc512f145030$export$a274e22fb40f762e = $1254dc512f145030$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("3dnb3", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", function () { return $2574908c73f8bd9e$export$39716b4af53f4ad; });

var $2vDrv = parcelRequire("2vDrv");

var $8wxT4 = parcelRequire("8wxT4");
function $2574908c73f8bd9e$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $2vDrv.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $2vDrv.createStrictSetupError)();
        },
        cx: $8wxT4.cx,
        XCSSProp () {
            throw (0, $2vDrv.createStrictSetupError)();
        }
    };
}

});
parcelRegister("2vDrv", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", function () { return $1d3d127d5cbba06e$export$c4df1cb0c2b4d77c; });
const $1d3d127d5cbba06e$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $1d3d127d5cbba06e$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});



parcelRegister("1gYOW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0ed676c6368342d3$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iDGsT = parcelRequire("iDGsT");

var $cogXd = parcelRequire("cogXd");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");
var $0ed676c6368342d3$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $0ed676c6368342d3$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $0ed676c6368342d3$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $0ed676c6368342d3$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $0ed676c6368342d3$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $0ed676c6368342d3$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $0ed676c6368342d3$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $0ed676c6368342d3$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $0ed676c6368342d3$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, $cogXd.default)(_ref, $0ed676c6368342d3$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $iDGsT.default)({}, ariaAttributes, {
        role: role,
        className: (0, $lyHO0.default)([
            $0ed676c6368342d3$var$styles.root,
            gap && $0ed676c6368342d3$var$columnGapMap[gap],
            columnGap && $0ed676c6368342d3$var$columnGapMap[columnGap],
            gap && $0ed676c6368342d3$var$rowGapMap[gap],
            rowGap && $0ed676c6368342d3$var$rowGapMap[rowGap],
            alignItems && $0ed676c6368342d3$var$alignItemsMap[alignItems],
            direction && $0ed676c6368342d3$var$flexDirectionMap[direction],
            justifyContent && $0ed676c6368342d3$var$justifyContentMap[justifyContent],
            wrap && $0ed676c6368342d3$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$0ed676c6368342d3$var$Flex.displayName = 'Flex';
var $0ed676c6368342d3$export$2e2bcd8739ae039 = $0ed676c6368342d3$var$Flex;

});


parcelRegister("1fq6V", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0e8b7235e015d9d6$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iDGsT = parcelRequire("iDGsT");

var $cogXd = parcelRequire("cogXd");

var $1oC0p = parcelRequire("1oC0p");


var $8wxT4 = parcelRequire("8wxT4");

var $hFmBq = parcelRequire("hFmBq");

var $Ej25m = parcelRequire("Ej25m");

var $dxfbe = parcelRequire("dxfbe");

var $ayxr0 = parcelRequire("ayxr0");

var $h8Thy = parcelRequire("h8Thy");
var $0e8b7235e015d9d6$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $0e8b7235e015d9d6$var$_excluded2 = [
    "className"
];
var $0e8b7235e015d9d6$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $0e8b7235e015d9d6$var$Pressable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $dxfbe.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $cogXd.default)(_ref, $0e8b7235e015d9d6$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $ayxr0.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $hFmBq.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.15.4",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $cogXd.default)(htmlAttributes, $0e8b7235e015d9d6$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement((0, $h8Thy.default), (0, $iDGsT.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $Ej25m.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $8wxT4.cx)($0e8b7235e015d9d6$var$styles.root, isDisabled && $0e8b7235e015d9d6$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $0e8b7235e015d9d6$export$2e2bcd8739ae039 = $0e8b7235e015d9d6$var$Pressable;

});
parcelRegister("hFmBq", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $cdc7cc6a928a0969$export$a4687b0234b40e28; });

var $gp1ED = parcelRequire("gp1ED");

var $1oC0p = parcelRequire("1oC0p");

var $5BLMs = parcelRequire("5BLMs");

var $95BYK = parcelRequire("95BYK");
function $cdc7cc6a928a0969$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cdc7cc6a928a0969$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cdc7cc6a928a0969$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gp1ED.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cdc7cc6a928a0969$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cdc7cc6a928a0969$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $5BLMs.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $95BYK.useTrackedRef)(analyticsData);
    var fnRef = (0, $95BYK.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $cdc7cc6a928a0969$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("5BLMs", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $415578acfffe4c6a$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $052f1 = parcelRequire("052f1");

var $gCN7N = parcelRequire("gCN7N");
function $415578acfffe4c6a$export$5bf35293e545f20c() {
    var analyticsContext = (0, $gCN7N.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $052f1.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("052f1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $00f234cf7f24a760$export$2e2bcd8739ae039; });

var $c5fcX = parcelRequire("c5fcX");

var $1L9xr = parcelRequire("1L9xr");

var $gk4W6 = parcelRequire("gk4W6");

var $hz9hK = parcelRequire("hz9hK");

var $gWRUU = parcelRequire("gWRUU");

var $bgMta = parcelRequire("bgMta");

var $9gsna = parcelRequire("9gsna");

var $gp1ED = parcelRequire("gp1ED");

var $iCnIq = parcelRequire("iCnIq");
function $00f234cf7f24a760$var$_callSuper(t, o, e) {
    return o = (0, $gWRUU.default)(o), (0, $hz9hK.default)(t, $00f234cf7f24a760$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $gWRUU.default)(t).constructor) : o.apply(t, e));
}
function $00f234cf7f24a760$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($00f234cf7f24a760$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $00f234cf7f24a760$var$_superPropGet(t, o, e, r) {
    var p = (0, $bgMta.default)((0, $gWRUU.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $00f234cf7f24a760$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $00f234cf7f24a760$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $00f234cf7f24a760$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $1L9xr.default)(this, UIAnalyticsEvent);
        _this = $00f234cf7f24a760$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $gp1ED.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $gp1ED.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $c5fcX.default)(_this.context);
            var handlers = (0, $c5fcX.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $gp1ED.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $9gsna.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $gk4W6.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $00f234cf7f24a760$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $iCnIq.default));

});
parcelRegister("bgMta", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8346c9588f0f2f7e$export$2e2bcd8739ae039; });

var $2fa4t = parcelRequire("2fa4t");
function $8346c9588f0f2f7e$export$2e2bcd8739ae039() {
    return $8346c9588f0f2f7e$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $2fa4t.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $8346c9588f0f2f7e$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("2fa4t", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1a24cb66b14070fb$export$2e2bcd8739ae039; });

var $gWRUU = parcelRequire("gWRUU");
function $1a24cb66b14070fb$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $gWRUU.default)(t)););
    return t;
}

});


parcelRegister("iCnIq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d8de2c0a145e20fd$export$2e2bcd8739ae039; });

var $5wtQz = parcelRequire("5wtQz");

var $1L9xr = parcelRequire("1L9xr");

var $gk4W6 = parcelRequire("gk4W6");

var $gp1ED = parcelRequire("gp1ED");
function $d8de2c0a145e20fd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d8de2c0a145e20fd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d8de2c0a145e20fd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gp1ED.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d8de2c0a145e20fd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d8de2c0a145e20fd$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $d8de2c0a145e20fd$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $d8de2c0a145e20fd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $1L9xr.default)(this, AnalyticsEvent);
        (0, $gp1ED.default)(this, "_isAnalyticsEvent", true);
        (0, $gp1ED.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $d8de2c0a145e20fd$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $gk4W6.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $5wtQz.default)(updater) === 'object') this.payload = $d8de2c0a145e20fd$var$_objectSpread($d8de2c0a145e20fd$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("gCN7N", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $c1a64d1522868def$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $c1a64d1522868def$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("95BYK", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $69e20a7c2c7a40b8$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $69e20a7c2c7a40b8$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("dxfbe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9daa21e870763cb6$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $9daa21e870763cb6$export$2e2bcd8739ae039() {}

});

parcelRegister("ayxr0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7af703cb9bdaba54$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $7af703cb9bdaba54$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("h8Thy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c7ae10e90a87fd28$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iDGsT = parcelRequire("iDGsT");

var $cogXd = parcelRequire("cogXd");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $39c3M = parcelRequire("39c3M");
var $c7ae10e90a87fd28$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $c7ae10e90a87fd28$var$_excluded2 = [
    "className"
];
var $c7ae10e90a87fd28$var$focusRingStyles = null;
var $c7ae10e90a87fd28$var$insetFocusRingStyles = null;
// This is added to override and reset global styles that apps might be applying - for example,
// at the time of writing, Jira has global styles that targets all button and anchor elements,
// adding an outline on :focus.
var $c7ae10e90a87fd28$var$outlineResetStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $c7ae10e90a87fd28$var$Focusable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $cogXd.default)(_ref, $c7ae10e90a87fd28$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $cogXd.default)(htmlAttributes, $c7ae10e90a87fd28$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $iDGsT.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $lyHO0.default)([
            "_mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            (0, $39c3M.fg)('platform_dst_compiled_primitives_outline_reset') && "_ymio1r31 _ypr0glyw _zcxs1o36",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $c7ae10e90a87fd28$export$2e2bcd8739ae039 = $c7ae10e90a87fd28$var$Focusable;

});


parcelRegister("eCBjk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aa518e7032829506$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $lyHO0 = parcelRequire("lyHO0");

var $1oC0p = parcelRequire("1oC0p");

var $etBkE = parcelRequire("etBkE");

var $j1TKk = parcelRequire("j1TKk");

var $5BwY0 = parcelRequire("5BwY0");
/**
 * Returns the appropriate circle stroke color.
 */ function $aa518e7032829506$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $j1TKk.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $j1TKk.N0), ")");
}
var $aa518e7032829506$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $aa518e7032829506$var$loadIn = null;
var $aa518e7032829506$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $aa518e7032829506$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $aa518e7032829506$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $5BwY0.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $aa518e7032829506$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $etBkE.default));
    $aa518e7032829506$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $lyHO0.default)([
            $aa518e7032829506$var$styles.wrapperStyles,
            $aa518e7032829506$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $lyHO0.default)([
            $aa518e7032829506$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $lyHO0.default)([
            $aa518e7032829506$var$styles.circleStyles
        ])
    })));
}));
var $aa518e7032829506$export$2e2bcd8739ae039 = $aa518e7032829506$var$Spinner;

});
parcelRegister("j1TKk", function(module, exports) {
$parcel$export(module.exports, "N0", function () { return $dda95a55022ff728$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $dda95a55022ff728$export$c39c0fe0f26207ae; });
// Reds
var $dda95a55022ff728$export$4b84fd0e2c617bd = '#FFEBE6';
var $dda95a55022ff728$export$b34b069eff244586 = '#FFBDAD';
var $dda95a55022ff728$export$be802dd0d8b57f35 = '#FF8F73';
var $dda95a55022ff728$export$60847d42f9da92a6 = '#FF7452';
var $dda95a55022ff728$export$4a7404f376229999 = '#FF5630';
var $dda95a55022ff728$export$2010d0fb4295b346 = '#DE350B';
var $dda95a55022ff728$export$2837b5a1a71d5c02 = '#BF2600';
var $dda95a55022ff728$export$8d9596b529bbb9cf = '#FFFAE6';
var $dda95a55022ff728$export$41060a744ab0b7ae = '#FFF0B3';
var $dda95a55022ff728$export$1cc05bbbf340e559 = '#FFE380';
var $dda95a55022ff728$export$5aae31392d72caaa = '#FFC400';
var $dda95a55022ff728$export$c6930421db9fa514 = '#FFAB00';
var $dda95a55022ff728$export$59619663aa6500fb = '#FF991F';
var $dda95a55022ff728$export$874739ea9e379ab6 = '#FF8B00';
var $dda95a55022ff728$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $dda95a55022ff728$export$69a3bf21b9686c2b = '#ABF5D1';
var $dda95a55022ff728$export$afbce1382ec95f73 = '#79F2C0';
var $dda95a55022ff728$export$747d86715d4175de = '#57D9A3';
var $dda95a55022ff728$export$940e1f69e873f202 = '#36B37E';
var $dda95a55022ff728$export$a49394138f7b8e85 = '#00875A';
var $dda95a55022ff728$export$6fa04827ac68a4fb = '#006644';
var $dda95a55022ff728$export$226de0355ed012f8 = '#DEEBFF';
var $dda95a55022ff728$export$8c13c2ee36917869 = '#B3D4FF';
var $dda95a55022ff728$export$ecfc1dff386a3e7a = '#4C9AFF';
var $dda95a55022ff728$export$215b7063051591f1 = '#2684FF';
var $dda95a55022ff728$export$e62e8919cca44969 = '#0065FF';
var $dda95a55022ff728$export$b3de0ae08da2ce64 = '#0052CC';
var $dda95a55022ff728$export$a6ee3d71bc067634 = '#0747A6';
var $dda95a55022ff728$export$67f15409e87642a1 = '#669DF1';
var $dda95a55022ff728$export$f0539dbc42dbb067 = '#8FB8F6';
var $dda95a55022ff728$export$363e4475840015bb = '#EAE6FF';
var $dda95a55022ff728$export$4b0a4417ed59760f = '#C0B6F2';
var $dda95a55022ff728$export$6011520a64d9a187 = '#998DD9';
var $dda95a55022ff728$export$a7175d4e9206bc80 = '#8777D9';
var $dda95a55022ff728$export$b48405b95304b5a1 = '#6554C0';
var $dda95a55022ff728$export$c71e4279dd54a18d = '#5243AA';
var $dda95a55022ff728$export$147899de772240ec = '#403294';
var $dda95a55022ff728$export$2cf711fe14c66f06 = '#E6FCFF';
var $dda95a55022ff728$export$7a8f4d33f6f9772c = '#B3F5FF';
var $dda95a55022ff728$export$776c9c497ef08533 = '#79E2F2';
var $dda95a55022ff728$export$69cb3ca10c1e330e = '#00C7E6';
var $dda95a55022ff728$export$9dc1ef0f3f48059b = '#00B8D9';
var $dda95a55022ff728$export$7c835c78b6fcdef8 = '#00A3BF';
var $dda95a55022ff728$export$6036577f95c3877e = '#008DA6';
var $dda95a55022ff728$export$29a4f05edc054374 = '#FFFFFF';
var $dda95a55022ff728$export$e655ef011c4aa1a2 = '#FAFBFC';
var $dda95a55022ff728$export$9fdfb749e33cdf97 = '#F4F5F7';
var $dda95a55022ff728$export$3e51e8f1440314ba = '#EBECF0';
var $dda95a55022ff728$export$1ce2d1575d444ceb = '#DFE1E6';
var $dda95a55022ff728$export$8754fc7e6d8b3000 = '#C1C7D0';
var $dda95a55022ff728$export$c2e91cbeada39b8b = '#B3BAC5';
var $dda95a55022ff728$export$5f71e19f3a7ad9de = '#A5ADBA';
var $dda95a55022ff728$export$eaa8c8a70ac22806 = '#97A0AF';
var $dda95a55022ff728$export$7c87d337fb91a97d = '#8993A4';
var $dda95a55022ff728$export$d6447c357493214f = '#7A869A';
var $dda95a55022ff728$export$f563ee71e9ee74cd = '#6B778C';
var $dda95a55022ff728$export$e2ef2124cf4024b1 = '#5E6C84';
var $dda95a55022ff728$export$eece5f492e429f08 = '#505F79';
var $dda95a55022ff728$export$c39c0fe0f26207ae = '#42526E';
var $dda95a55022ff728$export$7090862dc3038a9f = '#344563';
var $dda95a55022ff728$export$ad0bacf983b7ddaa = '#253858';
var $dda95a55022ff728$export$7d61b15e0da132af = '#172B4D';
var $dda95a55022ff728$export$fbda843f0a27fe96 = '#091E42';
var $dda95a55022ff728$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $dda95a55022ff728$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $dda95a55022ff728$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $dda95a55022ff728$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $dda95a55022ff728$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $dda95a55022ff728$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $dda95a55022ff728$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $dda95a55022ff728$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $dda95a55022ff728$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $dda95a55022ff728$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $dda95a55022ff728$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $dda95a55022ff728$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $dda95a55022ff728$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $dda95a55022ff728$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $dda95a55022ff728$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $dda95a55022ff728$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $dda95a55022ff728$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $dda95a55022ff728$export$2f6319cf7d736c2a = '#E6EDFA';
var $dda95a55022ff728$export$95126bc8884d6634 = '#DCE5F5';
var $dda95a55022ff728$export$8338d8c35d44ff1 = '#CED9EB';
var $dda95a55022ff728$export$5368d76ae4fbbda7 = '#B8C7E0';
var $dda95a55022ff728$export$9f0a771d16ec8d36 = '#ABBBD6';
var $dda95a55022ff728$export$abcf8c38338b4aa5 = '#9FB0CC';
var $dda95a55022ff728$export$97e81faa16a182c7 = '#8C9CB8';
var $dda95a55022ff728$export$bfe21c59123ecf33 = '#7988A3';
var $dda95a55022ff728$export$ee82aa2ea6a1558 = '#67758F';
var $dda95a55022ff728$export$682927c6ed76be02 = '#56637A';
var $dda95a55022ff728$export$91fd9994c5be9757 = '#455166';
var $dda95a55022ff728$export$d281fbfe3cff2df6 = '#3B475C';
var $dda95a55022ff728$export$3902c91d8b98a753 = '#313D52';
var $dda95a55022ff728$export$8e8133c1ba5845b5 = '#283447';
var $dda95a55022ff728$export$33ff357f6620b39 = '#202B3D';
var $dda95a55022ff728$export$633847cf062b69e0 = '#1B2638';
var $dda95a55022ff728$export$9776a6e503bdbf76 = '#121A29';
var $dda95a55022ff728$export$6c813d5160dff5db = '#0E1624';
var $dda95a55022ff728$export$3d4f271a500072a = '#0D1424';
var $dda95a55022ff728$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $dda95a55022ff728$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $dda95a55022ff728$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $dda95a55022ff728$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $dda95a55022ff728$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $dda95a55022ff728$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $dda95a55022ff728$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $dda95a55022ff728$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $dda95a55022ff728$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $dda95a55022ff728$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $dda95a55022ff728$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $dda95a55022ff728$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $dda95a55022ff728$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $dda95a55022ff728$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $dda95a55022ff728$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $dda95a55022ff728$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $dda95a55022ff728$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $dda95a55022ff728$export$d2adc5dedf09fced = '#292A2E';
var $dda95a55022ff728$export$f51762073d2bb381 = '#94C748';
var $dda95a55022ff728$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("5BwY0", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $4149faf661f51e15$export$4e9f1640bbe7a1a8; });
var $4149faf661f51e15$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("6Kvjy", function(module, exports) {
$parcel$export(module.exports, "inputCSS", function () { return $4e9f5451304e590c$export$14a7781d0ca7abea; });
$parcel$export(module.exports, "default", function () { return $4e9f5451304e590c$export$2e2bcd8739ae039; });
/* input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iDGsT = parcelRequire("iDGsT");

var $cogXd = parcelRequire("cogXd");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $8wxT4 = parcelRequire("8wxT4");

var $39c3M = parcelRequire("39c3M");

var $aFLwO = parcelRequire("aFLwO");
var $4e9f5451304e590c$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $4e9f5451304e590c$export$14a7781d0ca7abea = function inputCSS() {
    return {};
};
var $4e9f5451304e590c$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $4e9f5451304e590c$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $4e9f5451304e590c$var$nativeInputStylesOld = null;
var $4e9f5451304e590c$var$nativeInputStyles = null;
var $4e9f5451304e590c$var$hidden = null;
var $4e9f5451304e590c$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss;
    var _cleanCommonProps = (0, $aFLwO.cleanCommonProps)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, $cogXd.default)(_cleanCommonProps, $4e9f5451304e590c$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $aFLwO.getStyleProps)(props, 'input', {
        'input-container': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    if ((0, $39c3M.fg)('platform_do_not_clear_input_for_multiselect')) return /*#__PURE__*/ $1oC0p.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lyHO0.default)([
            $4e9f5451304e590c$var$inputStyles.root,
            isDisabled && $4e9f5451304e590c$var$inputStyles.disabled,
            (0, $8wxT4.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $1oC0p.createElement("input", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $lyHO0.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lyHO0.default)([
            $4e9f5451304e590c$var$inputStylesOld.root,
            isDisabled && $4e9f5451304e590c$var$inputStylesOld.disabled,
            (0, $8wxT4.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $1oC0p.createElement("input", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $lyHO0.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4e9f5451304e590c$export$2e2bcd8739ae039 = $4e9f5451304e590c$var$Input;

});

parcelRegister("4E002", function(module, exports) {
$parcel$export(module.exports, "menuCSS", function () { return $361ae5c83fecbf71$export$a228922d5ca42a79; });
$parcel$export(module.exports, "MenuPlacer", function () { return $361ae5c83fecbf71$export$f32337f3a7617699; });
$parcel$export(module.exports, "default", function () { return $361ae5c83fecbf71$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "menuListCSS", function () { return $361ae5c83fecbf71$export$abafed69cff95d5e; });
$parcel$export(module.exports, "MenuList", function () { return $361ae5c83fecbf71$export$d4c4e98c5044dc8; });
$parcel$export(module.exports, "noOptionsMessageCSS", function () { return $361ae5c83fecbf71$export$cf0e22534d8b0074; });
$parcel$export(module.exports, "loadingMessageCSS", function () { return $361ae5c83fecbf71$export$98ec46397a8cb3cd; });
$parcel$export(module.exports, "NoOptionsMessage", function () { return $361ae5c83fecbf71$export$d58b72b7d3c4072c; });
$parcel$export(module.exports, "LoadingMessage", function () { return $361ae5c83fecbf71$export$e928a71d039d3102; });
$parcel$export(module.exports, "menuPortalCSS", function () { return $361ae5c83fecbf71$export$1dbbeb9648d1fdc9; });
$parcel$export(module.exports, "MenuPortal", function () { return $361ae5c83fecbf71$export$793392f970497feb; });
/* menu.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $cogXd = parcelRequire("cogXd");

var $iDGsT = parcelRequire("iDGsT");

var $gp1ED = parcelRequire("gp1ED");

var $6uJws = parcelRequire("6uJws");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $8wxT4 = parcelRequire("8wxT4");

var $aWDwM = parcelRequire("aWDwM");

var $gUjjH = parcelRequire("gUjjH");

var $iComV = parcelRequire("iComV");

var $03T78 = parcelRequire("03T78");

var $aFLwO = parcelRequire("aFLwO");
var $361ae5c83fecbf71$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
], $361ae5c83fecbf71$var$_excluded2 = [
    "children",
    "innerProps",
    "xcss"
];
function $361ae5c83fecbf71$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $361ae5c83fecbf71$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $361ae5c83fecbf71$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gp1ED.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $361ae5c83fecbf71$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Menu
// ==============================
// Get Menu Placement
// ------------------------------
function $361ae5c83fecbf71$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = (0, $aFLwO.getScrollParent)(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : (0, $aFLwO.normalizedHeight)(scrollParent);
    var scrollTop = (0, $aFLwO.getScrollTop)(scrollParent);
    var menuTopFromParent = menuTop;
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTopFromParent;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $aFLwO.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $aFLwO.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $aFLwO.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $aFLwO.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $aFLwO.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
var $361ae5c83fecbf71$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $361ae5c83fecbf71$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qsd0yg",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
var $361ae5c83fecbf71$export$a228922d5ca42a79 = function menuCSS() {
    return {};
};
var $361ae5c83fecbf71$var$PortalPlacementContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $361ae5c83fecbf71$export$f32337f3a7617699 = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView;
    var _ref2 = (0, $1oC0p.useContext)($361ae5c83fecbf71$var$PortalPlacementContext) || {}, setPortalPlacement = _ref2.setPortalPlacement;
    var ref = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)(maxMenuHeight), _useState2 = (0, $6uJws.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(null), _useState4 = (0, $6uJws.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    // The minimum height of the control
    var controlHeight = 38;
    (0, $iComV.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $361ae5c83fecbf71$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: $361ae5c83fecbf71$var$_objectSpread($361ae5c83fecbf71$var$_objectSpread({}, props), {}, {
            placement: placement || $361ae5c83fecbf71$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $361ae5c83fecbf71$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $aFLwO.getStyleProps)(props, 'menu', {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lyHO0.default)([
            $361ae5c83fecbf71$var$menuStyles.root,
            $361ae5c83fecbf71$var$menuStyles[placement],
            (0, $8wxT4.cx)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$361ae5c83fecbf71$export$2e2bcd8739ae039 = $361ae5c83fecbf71$var$Menu;
var $361ae5c83fecbf71$export$abafed69cff95d5e = function menuListCSS() {
    return {};
};
var $361ae5c83fecbf71$var$menuListStyles = null;
var $361ae5c83fecbf71$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps2 = (0, $aFLwO.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lyHO0.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $8wxT4.cx)(className, xcss, '-MenuList')
        ]),
        style: $361ae5c83fecbf71$var$_objectSpread($361ae5c83fecbf71$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
// ==============================
// Menu Notices
// ==============================
var $361ae5c83fecbf71$var$noticeCSS = function noticeCSS() {
    return {};
};
var $361ae5c83fecbf71$var$noticeStyles = null;
var $361ae5c83fecbf71$export$cf0e22534d8b0074 = $361ae5c83fecbf71$var$noticeCSS;
var $361ae5c83fecbf71$export$98ec46397a8cb3cd = $361ae5c83fecbf71$var$noticeCSS;
var $361ae5c83fecbf71$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref3) {
    var _ref3$children = _ref3.children, children = _ref3$children === void 0 ? 'No options' : _ref3$children, innerProps = _ref3.innerProps, xcss = _ref3.xcss, restProps = (0, $cogXd.default)(_ref3, $361ae5c83fecbf71$var$_excluded);
    var _getStyleProps3 = (0, $aFLwO.getStyleProps)($361ae5c83fecbf71$var$_objectSpread($361ae5c83fecbf71$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lyHO0.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $8wxT4.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $1oC0p.createElement((0, $03T78.default), {
        color: "color.text.subtle"
    }, children));
};
var $361ae5c83fecbf71$export$e928a71d039d3102 = function LoadingMessage(_ref4) {
    var _ref4$children = _ref4.children, children = _ref4$children === void 0 ? 'Loading...' : _ref4$children, innerProps = _ref4.innerProps, xcss = _ref4.xcss, restProps = (0, $cogXd.default)(_ref4, $361ae5c83fecbf71$var$_excluded2);
    var _getStyleProps4 = (0, $aFLwO.getStyleProps)($361ae5c83fecbf71$var$_objectSpread($361ae5c83fecbf71$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), css = _getStyleProps4.css, className = _getStyleProps4.className;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lyHO0.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $8wxT4.cx)(className, xcss, '-LoadingMessage')
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $1oC0p.createElement((0, $03T78.default), {
        color: "color.text.subtle"
    }, children));
};
var $361ae5c83fecbf71$export$1dbbeb9648d1fdc9 = function menuPortalCSS() {
    return {};
};
var $361ae5c83fecbf71$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
var $361ae5c83fecbf71$export$793392f970497feb = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $1oC0p.useRef)(null);
    var cleanupRef = (0, $1oC0p.useRef)(null);
    var _useState5 = (0, $1oC0p.useState)($361ae5c83fecbf71$var$coercePlacement(menuPlacement)), _useState6 = (0, $6uJws.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $1oC0p.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $1oC0p.useState)(null), _useState8 = (0, $6uJws.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $1oC0p.useCallback)(function() {
        if (!controlElement) return;
        var rect = (0, $aFLwO.getBoundingClientObj)(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $iComV.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $1oC0p.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $aWDwM.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $iComV.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $1oC0p.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    var _getStyleProps5 = (0, $aFLwO.getStyleProps)($361ae5c83fecbf71$var$_objectSpread($361ae5c83fecbf71$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), css = _getStyleProps5.css, className = _getStyleProps5.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lyHO0.default)([
            $361ae5c83fecbf71$var$menuPortalStyles.root,
            (0, $8wxT4.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: $361ae5c83fecbf71$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': "".concat(computedPosition.rect.left, "px"),
            '--menu-position': menuPosition,
            '--menu-top': "".concat(computedPosition.offset, "px"),
            '--menu-width': "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $1oC0p.createElement($361ae5c83fecbf71$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $gUjjH.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});
parcelRegister("03T78", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $00bb086c680bdfb6$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $lmxXn = parcelRequire("lmxXn");

var $3oGO4 = parcelRequire("3oGO4");

var $Lk3I2 = parcelRequire("Lk3I2");
var $00bb086c680bdfb6$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $00bb086c680bdfb6$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $Lk3I2.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($00bb086c680bdfb6$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $00bb086c680bdfb6$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $00bb086c680bdfb6$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pmoej",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $00bb086c680bdfb6$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
var $00bb086c680bdfb6$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $00bb086c680bdfb6$var$textColorMap = {
    'color.text': "_syaz1fxt",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syaz1q28",
    'color.text.accent.orange.bolder': "_syaz1vps",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syazpnps",
    'color.text.accent.blue.bolder': "_syazsc1o",
    'color.text.accent.purple': "_syaz10m5",
    'color.text.accent.purple.bolder': "_syaz2ibx",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1dyx",
    'color.text.accent.gray.bolder': "_syaz1x9z",
    'color.text.disabled': "_syaz1lh4",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syazaqb7",
    'color.text.brand': "_syaz1e6v",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syazwx40",
    'color.text.warning.inverse': "_syazal3n",
    'color.text.success': "_syazy73q",
    'color.text.discovery': "_syazzjem",
    'color.text.information': "_syaze0os",
    'color.text.subtlest': "_syaz131l",
    'color.text.subtle': "_syaz1gjq",
    'color.link': "_syaz14q2",
    'color.link.pressed': "_syaz16c2",
    'color.link.visited': "_syazw7te",
    'color.link.visited.pressed': "_syazg3x0"
};
var $00bb086c680bdfb6$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $00bb086c680bdfb6$var$Text = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $lmxXn.default)($00bb086c680bdfb6$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $3oGO4.useHasTextAncestor)();
    var color = $00bb086c680bdfb6$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $1oC0p.createElement(Component, {
        id: id,
        className: (0, $lyHO0.default)([
            $00bb086c680bdfb6$var$styles.root,
            size && $00bb086c680bdfb6$var$fontSizeMap[size],
            color && $00bb086c680bdfb6$var$textColorMap[color],
            maxLines && $00bb086c680bdfb6$var$styles.truncation,
            maxLines === 1 && $00bb086c680bdfb6$var$styles.breakAll,
            align && $00bb086c680bdfb6$var$styles["textAlign.".concat(align)],
            weight && $00bb086c680bdfb6$var$fontWeightMap[weight],
            Component === 'em' && $00bb086c680bdfb6$var$styles['as.em'],
            Component === 'strong' && $00bb086c680bdfb6$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $1oC0p.createElement((0, $3oGO4.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $00bb086c680bdfb6$export$2e2bcd8739ae039 = $00bb086c680bdfb6$var$Text;

});
parcelRegister("3oGO4", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", function () { return $2794d17cf1fe7dbd$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $2794d17cf1fe7dbd$export$ae933c6cbe5643ad; });

var $1oC0p = parcelRequire("1oC0p");
var $2794d17cf1fe7dbd$var$HasTextAncestorContext = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
var $2794d17cf1fe7dbd$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $1oC0p.useContext)($2794d17cf1fe7dbd$var$HasTextAncestorContext);
};
var $2794d17cf1fe7dbd$export$ae933c6cbe5643ad = $2794d17cf1fe7dbd$var$HasTextAncestorContext.Provider;

});

parcelRegister("Lk3I2", function(module, exports) {
$parcel$export(module.exports, "useSurface", function () { return $08e3f32aa10488d9$export$1aeb4f6b93c4540d; });

var $1oC0p = parcelRequire("1oC0p");
var $08e3f32aa10488d9$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $08e3f32aa10488d9$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($08e3f32aa10488d9$export$1ca2a26fecb070ae);
};
$08e3f32aa10488d9$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("31ssg", function(module, exports) {
$parcel$export(module.exports, "multiValueCSS", function () { return $233789a7119e638f$export$23c213f7717186af; });
$parcel$export(module.exports, "multiValueLabelCSS", function () { return $233789a7119e638f$export$f40612612e0af964; });
$parcel$export(module.exports, "multiValueRemoveCSS", function () { return $233789a7119e638f$export$283467f6c4ac142b; });
$parcel$export(module.exports, "MultiValueContainer", function () { return $233789a7119e638f$export$cf9cf2a30a59265c; });
$parcel$export(module.exports, "MultiValueLabel", function () { return $233789a7119e638f$export$544aeea2a5ce08ee; });
$parcel$export(module.exports, "MultiValueRemove", function () { return $233789a7119e638f$export$8e1fd1a40e7a2f4a; });
$parcel$export(module.exports, "default", function () { return $233789a7119e638f$export$2e2bcd8739ae039; });
/* multi-value.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $gp1ED = parcelRequire("gp1ED");

var $iDGsT = parcelRequire("iDGsT");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $8wxT4 = parcelRequire("8wxT4");

var $bUDbi = parcelRequire("bUDbi");

var $4cJk8 = parcelRequire("4cJk8");

var $aFLwO = parcelRequire("aFLwO");
function $233789a7119e638f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $233789a7119e638f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $233789a7119e638f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gp1ED.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $233789a7119e638f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $233789a7119e638f$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1lh4 _bfhkm7j4",
    focused: "_syaz1wum _bfhkfg4m _16qs7ex6 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $233789a7119e638f$export$23c213f7717186af = function multiValueCSS() {
    return {};
};
var $233789a7119e638f$export$f40612612e0af964 = function multiValueLabelCSS() {
    return {};
};
var $233789a7119e638f$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c82smr _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1lh4",
    ellipsis: "_1bto1l2s"
};
var $233789a7119e638f$export$283467f6c4ac142b = function multiValueRemoveCSS() {
    return {};
};
var $233789a7119e638f$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu1rrc",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syaz1fxt _1e0c1txw _lswu1dx5 _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr3166n _13br1jjn _1di61dty _i5f81jjn"
};
var $233789a7119e638f$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lyHO0.default)([
            $233789a7119e638f$var$multiValueStyles.root,
            isDisabled && $233789a7119e638f$var$multiValueStyles.disabled,
            isFocused && $233789a7119e638f$var$multiValueStyles.focused,
            (0, $8wxT4.cx)(className, xcss, '-multiValue')
        ])
    }), children);
};
var $233789a7119e638f$export$544aeea2a5ce08ee = function MultiValueLabel(_ref2) {
    var children = _ref2.children, innerProps = _ref2.innerProps, isDisabled = _ref2.isDisabled, hasEllipsis = _ref2.hasEllipsis, className = _ref2.className, xcss = _ref2.xcss;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lyHO0.default)([
            $233789a7119e638f$var$multiValueLabelStyles.root,
            isDisabled && $233789a7119e638f$var$multiValueLabelStyles.disabled,
            hasEllipsis && $233789a7119e638f$var$multiValueLabelStyles.ellipsis,
            (0, $8wxT4.cx)(className, xcss, '-MultiValueLabel')
        ])
    }), children);
};
var $233789a7119e638f$var$disabledStyles = null;
var $233789a7119e638f$var$enabledStyles = null;
function $233789a7119e638f$export$8e1fd1a40e7a2f4a(_ref3) {
    var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, innerProps = _ref3.innerProps, className = _ref3.className, xcss = _ref3.xcss;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lyHO0.default)([
            $233789a7119e638f$var$multiValueRemoveStyles.root,
            isFocused && $233789a7119e638f$var$multiValueRemoveStyles.focused,
            (0, $8wxT4.cx)(className, xcss, '-MultiValueRemove')
        ])
    }), /*#__PURE__*/ $1oC0p.createElement("div", {
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
        className: (0, $lyHO0.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bUDbi))), {
        label: "",
        color: "currentColor",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4cJk8))),
        LEGACY_primaryColor: "transparent",
        LEGACY_secondaryColor: "inherit",
        LEGACY_size: "small",
        size: "small"
    })));
}
var $233789a7119e638f$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var ariaLabel = typeof children === 'string' ? children : data.label;
    var _getStyleProps = (0, $aFLwO.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $aFLwO.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $aFLwO.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    return /*#__PURE__*/ $1oC0p.createElement(Container, {
        data: data,
        innerProps: $233789a7119e638f$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $1oC0p.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $1oC0p.createElement(Remove, {
        data: data,
        innerProps: $233789a7119e638f$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: 'button',
            tabIndex: -1,
            'aria-label': "".concat(ariaLabel || 'option', ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$233789a7119e638f$export$2e2bcd8739ae039 = $233789a7119e638f$var$MultiValue;

});
parcelRegister("bUDbi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ac35141ba707ff6$var$_react = $8ac35141ba707ff6$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8ac35141ba707ff6$var$_baseNew = $8ac35141ba707ff6$var$_interopRequireDefault((parcelRequire("gxdRn")));
function $8ac35141ba707ff6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ac35141ba707ff6$var$CrossIcon = (props)=>/*#__PURE__*/ $8ac35141ba707ff6$var$_react.default.createElement($8ac35141ba707ff6$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$8ac35141ba707ff6$var$CrossIcon.displayName = 'CrossIcon';
var $8ac35141ba707ff6$var$_default = module.exports.default = $8ac35141ba707ff6$var$CrossIcon;

});


parcelRegister("c9hM5", function(module, exports) {
$parcel$export(module.exports, "optionCSS", function () { return $8d841cf36a0b253a$export$ef897119b7e920ba; });
$parcel$export(module.exports, "default", function () { return $8d841cf36a0b253a$export$2e2bcd8739ae039; });
/* option.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iDGsT = parcelRequire("iDGsT");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $8wxT4 = parcelRequire("8wxT4");

var $aFLwO = parcelRequire("aFLwO");
var $8d841cf36a0b253a$export$ef897119b7e920ba = function optionCSS() {
    return {};
};
var $8d841cf36a0b253a$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syaz1fxt _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di61dty",
    disabled: "_syaz1lh4 _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk166n _16qsu4to _112e5u6v",
    selected: "_syazaqb7 _bfhkfg4m _16qsu4to _1di619ru _112e5u6v",
    focusedSelected: "_bfhki1yw"
};
var $8d841cf36a0b253a$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $aFLwO.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lyHO0.default)([
            $8d841cf36a0b253a$var$optionStyles.root,
            isFocused && $8d841cf36a0b253a$var$optionStyles.focused,
            isSelected && $8d841cf36a0b253a$var$optionStyles.selected,
            isFocused && isSelected && $8d841cf36a0b253a$var$optionStyles.focusedSelected,
            isDisabled && $8d841cf36a0b253a$var$optionStyles.disabled,
            (0, $8wxT4.cx)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8d841cf36a0b253a$export$2e2bcd8739ae039 = $8d841cf36a0b253a$var$Option;

});

parcelRegister("iX5p5", function(module, exports) {
$parcel$export(module.exports, "placeholderCSS", function () { return $dcc1edc080b7e0ac$export$5f3ffacd6594d90f; });
$parcel$export(module.exports, "default", function () { return $dcc1edc080b7e0ac$export$2e2bcd8739ae039; });
/* placeholder.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iDGsT = parcelRequire("iDGsT");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $8wxT4 = parcelRequire("8wxT4");

var $aFLwO = parcelRequire("aFLwO");
var $dcc1edc080b7e0ac$export$5f3ffacd6594d90f = function placeholderCSS() {
    return {};
};
var $dcc1edc080b7e0ac$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz131l",
    disabled: "_syaz1lh4"
};
var $dcc1edc080b7e0ac$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $aFLwO.getStyleProps)(props, 'placeholder', {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lyHO0.default)([
            $dcc1edc080b7e0ac$var$placeholderStyles.root,
            isDisabled && $dcc1edc080b7e0ac$var$placeholderStyles.disabled,
            (0, $8wxT4.cx)(className, xcss, '-placeholder')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dcc1edc080b7e0ac$export$2e2bcd8739ae039 = $dcc1edc080b7e0ac$var$Placeholder;

});

parcelRegister("kf90p", function(module, exports) {
$parcel$export(module.exports, "css", function () { return $ebcc31b050b3cbc0$export$dbf350e5966cf602; });
$parcel$export(module.exports, "default", function () { return $ebcc31b050b3cbc0$export$2e2bcd8739ae039; });
/* single-value.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iDGsT = parcelRequire("iDGsT");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $8wxT4 = parcelRequire("8wxT4");

var $aFLwO = parcelRequire("aFLwO");
var $ebcc31b050b3cbc0$export$dbf350e5966cf602 = function css() {
    return {};
};
var $ebcc31b050b3cbc0$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1fxt",
    disalbed: "_syaz1lh4"
};
var $ebcc31b050b3cbc0$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $aFLwO.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $iDGsT.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lyHO0.default)([
            $ebcc31b050b3cbc0$var$styles.root,
            isDisabled && $ebcc31b050b3cbc0$var$styles.disalbed,
            (0, $8wxT4.cx)(className, xcss, '-singleValue')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ebcc31b050b3cbc0$export$2e2bcd8739ae039 = $ebcc31b050b3cbc0$var$SingleValue;

});


parcelRegister("a61YJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $759bffd019e7180b$export$2e2bcd8739ae039; });
/* dummy-input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iDGsT = parcelRequire("iDGsT");

var $cogXd = parcelRequire("cogXd");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $aFLwO = parcelRequire("aFLwO");
var $759bffd019e7180b$var$_excluded = [
    "innerRef"
];
var $759bffd019e7180b$var$dummyInputStyles = null;
function $759bffd019e7180b$export$2e2bcd8739ae039(_ref) {
    var innerRef = _ref.innerRef, props = (0, $cogXd.default)(_ref, $759bffd019e7180b$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $aFLwO.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ $1oC0p.createElement("input", (0, $iDGsT.default)({
        ref: innerRef,
        className: (0, $lyHO0.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}

});

parcelRegister("UaMzL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0a8d9840fcaa09d2$export$2e2bcd8739ae039; });
/* required-input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");

var $dxfbe = parcelRequire("dxfbe");
var $0a8d9840fcaa09d2$var$styles = null;
var $0a8d9840fcaa09d2$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return /*#__PURE__*/ $1oC0p.createElement("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $lyHO0.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $dxfbe.default)
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0a8d9840fcaa09d2$export$2e2bcd8739ae039 = $0a8d9840fcaa09d2$var$RequiredInput;

});

parcelRegister("iFQY6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $038225c0efc7aca9$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $04L35 = parcelRequire("04L35");

var $cze0J = parcelRequire("cze0J");
var $038225c0efc7aca9$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $038225c0efc7aca9$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = (0, $04L35.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = (0, $cze0J.default)({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, lockEnabled && /*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        onClick: $038225c0efc7aca9$var$blurSelectInput,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            position: 'fixed',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockStart: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineStart: 0
        }
    }), children(targetRef));
}

});
parcelRegister("04L35", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $00e4dec4affdd22a$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $aFLwO = parcelRequire("aFLwO");
var $00e4dec4affdd22a$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $00e4dec4affdd22a$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $1oC0p.useRef)(false);
    var isTop = (0, $1oC0p.useRef)(false);
    var touchStart = (0, $1oC0p.useRef)(0);
    var scrollTarget = (0, $1oC0p.useRef)(null);
    var handleEventDelta = (0, $1oC0p.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $00e4dec4affdd22a$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $1oC0p.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $1oC0p.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $1oC0p.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $1oC0p.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $aFLwO.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $1oC0p.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}

});

parcelRegister("cze0J", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $92639f2f20b2a0d5$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $92639f2f20b2a0d5$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $92639f2f20b2a0d5$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $92639f2f20b2a0d5$var$preventTouchMove(e) {
    e.preventDefault();
}
function $92639f2f20b2a0d5$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $92639f2f20b2a0d5$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $92639f2f20b2a0d5$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $92639f2f20b2a0d5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $92639f2f20b2a0d5$var$activeScrollLocks = 0;
var $92639f2f20b2a0d5$var$listenerOptions = {
    capture: false,
    passive: false
};
function $92639f2f20b2a0d5$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $1oC0p.useRef)({});
    var scrollTarget = (0, $1oC0p.useRef)(null);
    var addScrollLock = (0, $1oC0p.useCallback)(function(touchScrollTarget) {
        if (!$92639f2f20b2a0d5$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $92639f2f20b2a0d5$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $92639f2f20b2a0d5$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($92639f2f20b2a0d5$var$LOCK_STYLES).forEach(function(key) {
                var val = $92639f2f20b2a0d5$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $92639f2f20b2a0d5$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $92639f2f20b2a0d5$var$preventTouchMove, $92639f2f20b2a0d5$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $92639f2f20b2a0d5$var$preventInertiaScroll, $92639f2f20b2a0d5$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $92639f2f20b2a0d5$var$allowTouchMove, $92639f2f20b2a0d5$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $92639f2f20b2a0d5$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $1oC0p.useCallback)(function(touchScrollTarget) {
        if (!$92639f2f20b2a0d5$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $92639f2f20b2a0d5$var$activeScrollLocks = Math.max($92639f2f20b2a0d5$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $92639f2f20b2a0d5$var$activeScrollLocks < 1) $92639f2f20b2a0d5$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $92639f2f20b2a0d5$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $92639f2f20b2a0d5$var$preventTouchMove, $92639f2f20b2a0d5$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $92639f2f20b2a0d5$var$preventInertiaScroll, $92639f2f20b2a0d5$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $92639f2f20b2a0d5$var$allowTouchMove, $92639f2f20b2a0d5$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}

});


parcelRegister("gFMof", function(module, exports) {
$parcel$export(module.exports, "NotifyOpenLayerObserver", function () { return $c23602ed970de311$export$17baa7c95b6ba1b8; });

var $6P6Jp = parcelRequire("6P6Jp");
function $c23602ed970de311$export$17baa7c95b6ba1b8(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    // @ts-ignore - hot-116676
    (0, $6P6Jp.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("go0Tl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bedf944bd2704039$export$2e2bcd8739ae039; });

var $gp1ED = parcelRequire("gp1ED");

var $1oC0p = parcelRequire("1oC0p");

var $6T1bf = parcelRequire("6T1bf");

var $8Xa0R = parcelRequire("8Xa0R");
function $bedf944bd2704039$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bedf944bd2704039$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bedf944bd2704039$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gp1ED.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bedf944bd2704039$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Root Container
// ==============================
var $bedf944bd2704039$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isOptionDisabled = selectProps.isOptionDisabled, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, isLoading = selectProps.isLoading;
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $1oC0p.useMemo)(function() {
        return $bedf944bd2704039$var$_objectSpread($bedf944bd2704039$var$_objectSpread({}, (0, $6T1bf.defaultAriaLiveMessages)), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $1oC0p.useMemo)(function() {
        var message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            var onChangeProps = $bedf944bd2704039$var$_objectSpread({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    var ariaResults = (0, $1oC0p.useMemo)(function() {
        var resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ScreenReaderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8Xa0R.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8Xa0R.default), {
        "aria-live": ariaLive // Should be undefined by default unless a specific use case requires it
        ,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bedf944bd2704039$export$2e2bcd8739ae039 = $bedf944bd2704039$var$LiveRegion;

});
parcelRegister("6T1bf", function(module, exports) {
$parcel$export(module.exports, "defaultAriaLiveMessages", function () { return $5038cb87e164485e$export$a7265767c78f9bae; });
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ var $5038cb87e164485e$export$a7265767c78f9bae = {
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? "option ".concat(label, ", deselected") : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? "option ".concat(label, ", selected.") : '';
            default:
                return '';
        }
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : '';
    }
};

});

parcelRegister("8Xa0R", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $684b99c17c95482c$export$2e2bcd8739ae039; });
/* a11y-text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iDGsT = parcelRequire("iDGsT");

var $1oC0p = parcelRequire("1oC0p");

var $lyHO0 = parcelRequire("lyHO0");
// Assistive text to describe visual elements. Hidden for sighted users.
var $684b99c17c95482c$var$styles = null;
var $684b99c17c95482c$var$A11yText = function A11yText(props) {
    return /*#__PURE__*/ $1oC0p.createElement("span", (0, $iDGsT.default)({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $lyHO0.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
};
var $684b99c17c95482c$export$2e2bcd8739ae039 = $684b99c17c95482c$var$A11yText;

});


parcelRegister("gdrG4", function(module, exports) {
$parcel$export(module.exports, "createFilter", function () { return $bce35467d268c352$export$5d81789ff4aeccdf; });

var $gp1ED = parcelRequire("gp1ED");

var $dWJ7u = parcelRequire("dWJ7u");

var $gGpRe = parcelRequire("gGpRe");
function $bce35467d268c352$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bce35467d268c352$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bce35467d268c352$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gp1ED.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bce35467d268c352$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bce35467d268c352$var$memoizedStripDiacriticsForInput = (0, $dWJ7u.default)((0, $gGpRe.stripDiacritics));
var $bce35467d268c352$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $bce35467d268c352$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $bce35467d268c352$export$5d81789ff4aeccdf = function createFilter(config) {
    return function(option, rawInput) {
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = $bce35467d268c352$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $bce35467d268c352$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $bce35467d268c352$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $bce35467d268c352$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $bce35467d268c352$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $gGpRe.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};

});
parcelRegister("gGpRe", function(module, exports) {
$parcel$export(module.exports, "stripDiacritics", function () { return $c254a062e8f846ff$export$b5bee4b27048330b; });
var $c254a062e8f846ff$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $c254a062e8f846ff$var$anyDiacritic = new RegExp('[' + $c254a062e8f846ff$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $c254a062e8f846ff$var$diacriticToBase = {};
for(var $c254a062e8f846ff$var$i = 0; $c254a062e8f846ff$var$i < $c254a062e8f846ff$var$diacritics.length; $c254a062e8f846ff$var$i++){
    var $c254a062e8f846ff$var$diacritic = $c254a062e8f846ff$var$diacritics[$c254a062e8f846ff$var$i];
    for(var $c254a062e8f846ff$var$j = 0; $c254a062e8f846ff$var$j < $c254a062e8f846ff$var$diacritic.letters.length; $c254a062e8f846ff$var$j++)$c254a062e8f846ff$var$diacriticToBase[$c254a062e8f846ff$var$diacritic.letters[$c254a062e8f846ff$var$j]] = $c254a062e8f846ff$var$diacritic.base;
}
var $c254a062e8f846ff$export$b5bee4b27048330b = function stripDiacritics(str) {
    return str.replace($c254a062e8f846ff$var$anyDiacritic, function(match) {
        return $c254a062e8f846ff$var$diacriticToBase[match];
    });
};

});


parcelRegister("2tUXn", function(module, exports) {
$parcel$export(module.exports, "defaultStyles", function () { return $1cea78a2b0e026df$export$214b055320e0bf32; });
$parcel$export(module.exports, "mergeStyles", function () { return $1cea78a2b0e026df$export$e618dc39ac9ad607; });

var $gp1ED = parcelRequire("gp1ED");

var $4jkgc = parcelRequire("4jkgc");

var $gm3od = parcelRequire("gm3od");

var $bY2JO = parcelRequire("bY2JO");

var $czEWC = parcelRequire("czEWC");

var $6Kvjy = parcelRequire("6Kvjy");

var $4E002 = parcelRequire("4E002");

var $31ssg = parcelRequire("31ssg");

var $c9hM5 = parcelRequire("c9hM5");

var $iX5p5 = parcelRequire("iX5p5");

var $kf90p = parcelRequire("kf90p");
function $1cea78a2b0e026df$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1cea78a2b0e026df$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1cea78a2b0e026df$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gp1ED.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1cea78a2b0e026df$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1cea78a2b0e026df$export$214b055320e0bf32 = {
    clearIndicator: (0, $czEWC.clearIndicatorCSS),
    container: (0, $4jkgc.containerCSS),
    control: (0, $gm3od.css),
    dropdownIndicator: (0, $czEWC.dropdownIndicatorCSS),
    group: (0, $bY2JO.groupCSS),
    groupHeading: (0, $bY2JO.groupHeadingCSS),
    indicatorsContainer: (0, $4jkgc.indicatorsContainerCSS),
    input: (0, $6Kvjy.inputCSS),
    loadingIndicator: (0, $czEWC.loadingIndicatorCSS),
    loadingMessage: (0, $4E002.loadingMessageCSS),
    menu: (0, $4E002.menuCSS),
    menuList: (0, $4E002.menuListCSS),
    menuPortal: (0, $4E002.menuPortalCSS),
    multiValue: (0, $31ssg.multiValueCSS),
    multiValueLabel: (0, $31ssg.multiValueLabelCSS),
    multiValueRemove: (0, $31ssg.multiValueRemoveCSS),
    noOptionsMessage: (0, $4E002.noOptionsMessageCSS),
    option: (0, $c9hM5.optionCSS),
    placeholder: (0, $iX5p5.placeholderCSS),
    singleValue: (0, $kf90p.css),
    valueContainer: (0, $4jkgc.valueContainerCSS)
};
function $1cea78a2b0e026df$export$e618dc39ac9ad607(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = $1cea78a2b0e026df$var$_objectSpread({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});


parcelRegister("6FgUR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4da3b19402762973$export$2e2bcd8739ae039; });

var $gp1ED = parcelRequire("gp1ED");

var $6uJws = parcelRequire("6uJws");

var $cogXd = parcelRequire("cogXd");

var $1oC0p = parcelRequire("1oC0p");

var $aFLwO = parcelRequire("aFLwO");
var $4da3b19402762973$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $4da3b19402762973$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4da3b19402762973$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4da3b19402762973$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gp1ED.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4da3b19402762973$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4da3b19402762973$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $cogXd.default)(_ref, $4da3b19402762973$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $1oC0p.useRef)(undefined);
    var mounted = (0, $1oC0p.useRef)(false);
    var _useState = (0, $1oC0p.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $6uJws.default)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, $6uJws.default)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(propsDefaultOptions === true), _useState6 = (0, $6uJws.default)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $1oC0p.useState)(undefined), _useState8 = (0, $6uJws.default)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $1oC0p.useState)([]), _useState0 = (0, $6uJws.default)(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $1oC0p.useState)(false), _useState10 = (0, $6uJws.default)(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $1oC0p.useState)({}), _useState12 = (0, $6uJws.default)(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $1oC0p.useState)(undefined), _useState14 = (0, $6uJws.default)(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $1oC0p.useState)(undefined), _useState16 = (0, $6uJws.default)(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $1oC0p.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $1oC0p.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $1oC0p.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $aFLwO.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $4da3b19402762973$var$_objectSpread($4da3b19402762973$var$_objectSpread({}, optionsCache), {}, (0, $gp1ED.default)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $4da3b19402762973$var$_objectSpread($4da3b19402762973$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});

parcelRegister("dK6Gj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a014c10aee0589d1$export$2e2bcd8739ae039; });

var $gp1ED = parcelRequire("gp1ED");

var $6uJws = parcelRequire("6uJws");

var $cogXd = parcelRequire("cogXd");

var $1oC0p = parcelRequire("1oC0p");
var $a014c10aee0589d1$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $a014c10aee0589d1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a014c10aee0589d1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a014c10aee0589d1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gp1ED.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a014c10aee0589d1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a014c10aee0589d1$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $cogXd.default)(_ref, $a014c10aee0589d1$var$_excluded);
    var _useState = (0, $1oC0p.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $6uJws.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $6uJws.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $6uJws.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $1oC0p.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $1oC0p.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $1oC0p.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $1oC0p.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return $a014c10aee0589d1$var$_objectSpread($a014c10aee0589d1$var$_objectSpread({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});



//# sourceMappingURL=manual-triggers-modal.2a6ff6da.js.map
